import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const messages = {
  en: {
    hearttoheart: 'Heart-to-heart talk',
    withPeople: 'with people.',
    showyourtalent: 'Show your talent and get MPoints',
    whatsnew: "What's new ",
    hearttoheart2: 'Go live with',
    withPeople2: 'your favorite product',
    showyourtalent2: 'and make money',
    callingTitle: 'Calling',
    callingDesc:
      'Now call your favorite broadcaster by using MPoints. (MPoints facility would not be available on calls less than 30 seconds.)',
    heartTitle: 'Send heart',
    heartDesc:
      'Tap Hearts on live video of broadcaster to send hearts to broadcaster',
    questionTitle: 'Questionnaire',
    ShoppingTitle: 'Shopping',
    shoppingDesc:
      'Go live with your purchased item and if someone makes purchase from your live product link, then you will get a bonus.',
    questionDesc:
      'Now your audience can ask you questions, and when you answer these questions you will get MPoints. All you have to do is, select the category of questionnaire while going live.',
    Questionare: 'Questionare',
    questionasked: 'The old questions you asked',
    category: {
      // money91: "Money91",
      questionary: 'Questionnaire',
      shopping: 'Shopping'
      // love: "Love",
      // poetry: "Poetry",
      // politics: "Politics",
      // religious: "Religious",
      // others: "Others",
    },
    categoryNew: {
      // money91: {
      //   name: "Money91",
      //   paragraph: "Go live and show new friends or your talents and earn tips."
      // },
      questionary: {
        name: 'Questionnaire',
        paragraph:
          'Ask the broadcaster a question and award him a tip with MPoints or wallet or go live with this category yourself and answer your audience questions and earn money.'
      },
      shopping: {
        name: 'Shopping',
        paragraph:
          "Watch the live video of Mall91's products from those who have bought them or go live on their own.You earn more from your purchased products,if someone buys that product from your live."
      }
    },
    goLive: 'Go Live',
    whichtopic: 'On Which topic ',
    talkabout: 'will you talk about?',
    rules: 'Terms and Conditions',
    togolive: 'of going live',
    rule1: 'You must have more than 100 or more than 100 followers to go live.',
    rule2:
      'You can be permanently banned from Money91 if you are making objectionable live.',
    rule3:
      'Inappropriate behavior or sexual and violent content may result in your account being banned and law enforcement officials may be notified.',
    rule4:
      'We want to strengthen your relationships through the experiences you share, which you really care about. That is why we build systems that try to understand what you and others care about, and that information helps you create, discover, join and share those experiences.',
    rule5:
      'We do not claim ownership of your content, but you give us the license to use it.',
    rule6: 'We hope your experience is favorable on Money91 Live.',
    back: 'Go back',
    stop: 'Stop',
    doyou: 'Do you want to get',
    out: 'out of live?',
    yes: 'Yes',
    no: 'No',
    follow: 'Follow',
    following: 'Following',
    ifuliketalent:
      'If you like my talent then you can encourage me with a gift',
    give: 'Give',
    givereward: 'Give Reward',
    writequestion: 'Write your question',
    whattogiveforquestion:
      'You have to pay either Wallet or MPoints for the answer of your question.',
    writequeshere: 'Write your question here',
    continue: 'Continue',
    payforques: 'Pay for your question',
    yourques: 'Your Question',
    topay: 'Make payment',
    questiontobeanswer: 'New question to be answered',
    answeredquestion: 'Answered',
    startchat: ' Start chat',
    noquestion: 'You have no questions to answer.',
    netSlow:
      'your internet speed is slow your golive experience may be effect.',
    startNet: 'please start your internet connection',
    upgradeApp: 'Please upgrade the app to use this feature.',
    appId: 'Get App ID first!',
    startCamera:
      'Please allow GoLive to access Camera and Storage to start broadcasting.',
    broadcastKicked: 'The broadcaster kicked you out of the room.',
    plzchat: 'Start chat',
    liveItem: 'Select item to live',
    changecategory: 'Change your category',
    CallingYou: 'Calling You...',
    For: 'For',
    MPointGiveYou: 'MPoint Give You',
    accountMayBlock:
      'Inappropriate behavior or sexual and violent content may result in your account being banned and reported to law enforcement officers.',
    writeComment: 'Please write comment first !',
    addedQues: 'A new question is added',
    CallDND: 'Call DND',
    CallBusy: 'Call Busy',
    Openlink: 'Open link',
    Wallet: 'Wallet',
    CallingggYou: 'You are calling...',
    reportPost:
      'Thank you for reporting this post. We have recorded your response.',
    noWallet: 'no wallet no cash',
    Kindlyaskquestion: 'Kindly ask question.',
    wentwrong: 'something went wrong',
    serverNotRespo: 'server not responding',
    IncreaseMPoint: 'Increase MPoint',
    submitedques: 'Your question has been submitted successfully.',
    Nobalance: 'No balance',
    liveEnded: 'Live has ended.',
    sellYourProduct: 'Sell your product',
    inspireViewer: 'Inspire your viewer to purchase items',
    earnOnClick: 'Earned on every click / sale',
    earnMPoint: 'Get MPoint on every click, and earn up to 30% per item sale',
    clickToliveItem: 'Live item with one click',
    boughtthisdeal: 'People have bought this deal',
    saleprice: 'sale price:',
    makeLive: 'Make Live',
    noProduct: "You don't have any product",
    MoreItem: 'More Item',
    Close: 'Close',
    Position: 'Position',
    NameName: 'Name',
    DurationTime: 'Duration Time',
    Score: 'Score',
    WINrupees: 'WIN ₹10000',
    EventEnd: 'Event End',
    buyNow: 'Buy now'
  },
  bn: {
    hearttoheart: 'হৃদয় থেকে হৃদয় আলাপ',
    withPeople: 'মানুষের সাথে আপনার প্রতিভা দেখান',
    showyourtalent: 'এবং এম ক্যাশ পেতে',
    hearttoheart2: 'লাইভ যান',
    withPeople2: 'আপনার প্রিয় পণ্য সহ',
    showyourtalent2: 'এবং অর্থ উপার্জন',
    whatsnew: 'নতুন কি',
    callingTitle: 'কল করা হচ্ছে',
    callingDesc:
      'এখন আপনার প্রিয় সম্প্রচারকে এমক্যাশ কল করুন call (এমক্যাশ 30 সেকেন্ডেরও কম কলগুলিতে উপলব্ধ হবে না))',
    heartTitle: 'হৃদয় পাঠান',
    heartDesc:
      'ব্রডকাস্টারের ভিডিওতে হার্টস লাইভ অন ট্যাপ করুন এবং হার্টস ব্রডকাস্টারকে পাঠান',
    ShoppingTitle: 'ক্রয়',
    shoppingDesc:
      'মল 91 থেকে কেনা পণ্য থেকে লাইভ পণ্য এবং লাইভ রেফারাল টাকা। আপনার কেনা আইটেমের সাথে লাইভ যান এবং যদি কেউ আপনাকে জীবিত কিনে তবে আপনি একটি বোনাস পাবেন।',
    questionTitle: 'প্রশ্নাবলী',
    questionDesc:
      'এখন আপনার শ্রোতা আপনাকে প্রশ্ন জিজ্ঞাসা করতে পারেন, এবং যখন আপনি এই প্রশ্নের উত্তর দেন, তখন আপনি এমএসিএশকে শুধু তাই করবেন যাতে আপনি বিভাগের প্রশ্নাবলী বিভাগে থাকেন। তারপরে আপনার শ্রোতা প্রশ্ন জিজ্ঞাসা করার একটি প্রশ্ন পাবেন এবং আপনিও তার জন্য আপনার MPoint মুক্ত করতে পারেন।',
    Questionare: 'প্রশ্নাবলী',
    questionasked: 'আপনি জিজ্ঞাসা পুরানো প্রশ্ন',
    category: {
      // money91: "টাকানয়এক",
      questionary: 'প্রশ্নাবলী',
      shopping: 'কেনাকাটা'
      // love: "ভালবাসা",
      // poetry: "কবিতা",
      // politics: "রাজনীতি",
      // religious: "ধার্মিক",
      // others: "অন্যরা"
    },
    categoryNew: {
      // money91: {
      //   name: "টাকানয়এক",
      //   paragraph:
      //     "লাইভ যান এবং নতুন বন্ধু বা আপনার প্রতিভা প্রদর্শন এবং টিপস উপার্জন."
      // },
      questionary: {
        name: 'প্রশ্নাবলী',
        paragraph:
          'ব্রডকাস্টারকে একটি প্রশ্ন জিজ্ঞাসা করুন এবং তাকে বা এ টিপ দিন অথবা এই বিভাগটি দিয়ে সরাসরি যান এবং আপনার দর্শকদের প্রশ্নের উত্তর দিন এবং অর্থ উপার্জন করুন।'
      },
      shopping: {
        name: 'কেনাকাটা',
        paragraph:
          'যারা মাল কিনেছেন বা তাদের নিজস্ব জীবনযাপন করেছেন তাদের কাছ থেকে মল 91 এর লাইভ ভিডিও দেখুন। যদি কেউ আপনার লাইভ পণ্যটি কিনে নেয় তবে আপনি আপনার ক্রয়কৃত পণ্যগুলি থেকে আরো উপার্জন করেন।'
      }
    },
    goLive: 'সরাসরি যাও',
    whichtopic: 'কোন বিষয়ে',
    talkabout: 'তুমি কি কথা বলবে?',
    rules: 'শর্তাবলী',
    togolive: 'লাইভ যাচ্ছে',
    rule1: 'আপনি লাইভ যেতে 100 বা 100 এরও বেশি অনুসারী থাকতে হবে',
    rule2:
      'আপনি যদি আপত্তিকর লাইভ করেন তবে আপনি Money91 থেকে স্থায়ীভাবে নিষিদ্ধ হতে পারেন',
    rule3:
      'অনুপযুক্ত আচরণ বা যৌন এবং সহিংস সামগ্রী আপনার অ্যাকাউন্ট নিষিদ্ধ করা হতে পারে এবং আইন প্রয়োগকারী কর্মকর্তাকে অবহিত করা হতে পারে।',
    rule4:
      'আমরা আপনার অভিজ্ঞতাগুলি ভাগ করে নেওয়ার মাধ্যমে আপনার সম্পর্ককে শক্তিশালী করতে চাই, যা আপনি সত্যিই যত্নশীল। এজন্যই আমরা এমন সিস্টেম তৈরি করি যা আপনার এবং অন্যদের কীসের যত্ন করে তা বোঝার চেষ্টা করে এবং সেই তথ্যটি আপনাকে সেই অভিজ্ঞতাগুলি তৈরি, আবিষ্কার, যোগদান এবং ভাগ করে নেওয়ার ক্ষেত্রে সহায়তা করে।',
    rule5:
      'আমরা আপনার সামগ্রীর মালিকানা দাবি করি না, তবে আপনি এটি ব্যবহার করার জন্য আমাদের লাইসেন্স দিবেন।',
    rule6: 'আমরা আশা করি আপনার অভিজ্ঞতা মানি91 লাইভ এ অনুকূল।',
    back: 'ফিরে যাও',
    stop: 'থামুন',
    doyou: 'কি আপনি চান',
    out: 'লাইভ আউট',
    yes: 'হাঁ',
    no: 'না',
    follow: 'অনুসরণ করা',
    following: 'অনুসরণ করা হয়',
    ifuliketalent:
      'আপনি যদি আমার প্রতিভা পছন্দ করেন তবে আপনি আমাকে একটি উপহার দিয়ে উত্সাহিত করতে পারেন',
    give: 'এটা দাও',
    givereward: 'পুরস্কার দিন',
    writequestion: 'আপনার প্রশ্ন লিখুন',
    whattogiveforquestion:
      'আপনার প্রশ্নের উত্তরের জন্য আপনাকে  বা  ক্যাশ হিসাবে অর্থ প্রদান করতে হবে।',
    writequeshere: 'এখানে আপনার প্রশ্ন লিখুন',
    continue: 'চালিয়ে',
    payforques: 'আপনার প্রশ্নের জন্য অর্থ প্রদান',
    yourques: 'আপনার প্রশ্ন',
    topay: 'পেমেন্ট করুন',
    questiontobeanswer: 'উত্তর দিতে নতুন প্রশ্ন',
    answeredquestion: 'উত্তর',
    startchat: 'কথোপকথন শুরু করুন',
    noquestion: 'আপনি উত্তর দিতে কোন প্রশ্ন আছে।',
    netSlow: 'আপনার ইন্টারনেটের গতি ধীর আপনার গ্লোভ অভিজ্ঞতা কার্যকর হতে পারে।',
    startNet: 'আপনার ইন্টারনেট সংযোগ শুরু করুন',
    upgradeApp: 'এই বৈশিষ্ট্যটি ব্যবহার করতে দয়া করে অ্যাপটিকে আপগ্রেড করুন।',
    appId: 'প্রথমে অ্যাপ আইডি পান!',
    startCamera:
      'সম্প্রচার শুরু করতে দয়া করে  কে ক্যামেরা এবং স্টোরেজ অ্যাক্সেসের অনুমতি দিন।',
    broadcastKicked: 'সম্প্রচারক আপনাকে ঘর থেকে বের করে দিয়েছে।',
    plzchat: 'চ্যাট শুরু করুন',
    liveItem: 'বাঁচতে আইটেম নির্বাচন করুন',
    changecategory: 'আপনার বিভাগ পরিবর্তন করুন',
    CallingYou: 'আপনাকে ফোন করছি ...',
    For: 'জন্য',
    MPointGiveYou: 'ইউপিউন গিভ ইউ',
    accountMayBlock:
      'অনুপযুক্ত আচরণ বা যৌন এবং হিংসাত্মক সামগ্রীর ফলে আপনার অ্যাকাউন্টটি নিষিদ্ধ হয়ে আইন প্রয়োগকারী কর্মকর্তাদের কাছে প্রতিবেদন করা হতে পারে।',
    writeComment: 'প্রথমে মন্তব্য লিখুন!',
    addedQues: 'একটি নতুন প্রশ্ন যুক্ত করা হয়েছে',
    CallDND: 'কল করুন ডিএনডি',
    CallBusy: 'ব্যাসিকে ফোন করুন',
    Openlink: 'খোলা সংযুক্তি',
    Wallet: 'মানিব্যাগ',
    CallingggYou: 'আপনি কল করছেন ...',
    reportPost:
      'এই পোস্টে রিপোর্ট করার জন্য আপনাকে ধন্যবাদ। আমরা আপনার প্রতিক্রিয়া রেকর্ড করেছি।',
    noWallet: 'মানিব্যাগ নেই নগদ',
    Kindlyaskquestion: 'দয়া করে প্রশ্ন জিজ্ঞাসা করুন।',
    wentwrong: 'কিছু ভুল হয়েছে',
    serverNotRespo: 'সার্ভার সাড়া দিচ্ছে না',
    IncreaseMPoint: 'এমপিউন্ট বাড়ান',
    submitedques: 'আপনার প্রশ্ন সফলভাবে জমা দেওয়া হয়েছে।',
    Nobalance: 'ভারসাম্য নেই',
    liveEnded: 'লাইভ শেষ হয়েছে।',
    sellYourProduct: 'আপনার পণ্য বিক্রয়',
    inspireViewer: 'আপনার দর্শকদের আইটেমগুলি কেনার জন্য অনুপ্রাণিত করুন',
    earnOnClick: 'প্রতিটি ক্লিক / বিক্রয় উপার্জন',
    earnMPoint:
      'প্রতিটি ক্লিকে এমপিউইন্ট পান এবং প্রতি আইটেম বিক্রয় 30% পর্যন্ত উপার্জন করুন',
    clickToliveItem: 'এক ক্লিকে লাইভ আইটেম',
    boughtthisdeal: 'লোকেরা এই চুক্তিটি কিনেছে',
    saleprice: 'বিক্রয় মূল্য:',
    makeLive: 'লাইভ করুন',
    noProduct: 'আপনার কোনও পণ্য নেই',
    MoreItem: 'আরও আইটেম',
    Close: 'ঘনিষ্ঠ',
    Position: 'অবস্থান',
    NameName: 'নাম',
    DurationTime: 'সময়কাল',
    Score: 'স্কোর',
    WINrupees: 'বিজয় ₹ 10000',
    EventEnd: 'ইভেন্টের সমাপ্তি',
    buyNow: 'এখন কেন'
  },
  gu: {
    hearttoheart: 'હાર્ટ-ટુ-હાર્ટ ટૉક',
    withPeople: 'લોકો સાથે તમારી પ્રતિભા બતાવો',
    showyourtalent: 'અને એમ-કેશ મેળવો',
    hearttoheart2: 'જીવંત જાઓ',
    withPeople2: 'તમારા મનપસંદ ઉત્પાદન સાથે',
    showyourtalent2: 'અને પૈસા બનાવો',
    callingTitle: 'બોલાવવું',
    callingDesc:
      'હવે તમારા મનપસંદ બ્રોડકાસ્ટરને એમકેશ દ્વારા ક callલ કરો. (એમકેશ 30 સેકંડથી ઓછા ક callsલ્સ પર ઉપલબ્ધ રહેશે નહીં.)',
    heartTitle: 'હૃદય મોકલો',
    heartDesc:
      'બ્રોડકાસ્ટર વિડિઓ પર હાર્ટ્સ લાઇવ પર ટેપ કરો અને હાર્ટ્સ બ્રોડકાસ્ટર પર મોકલો',
    whatsnew: 'નવું શું છે',
    ShoppingTitle: 'ખરીદી',
    shoppingDesc:
      'મોલ 91 માંથી ખરીદેલ માલમાંથી લાઇવ માલ અને લાઇવ રેફરલ્સ મની. તમારી ખરીદી કરેલી આઇટમ સાથે રહો અને જો કોઈ તમને લાઇવ ખરીદે છે, તો તમને બોનસ મળશે.',
    questionTitle: 'પ્રશ્નાવલી',
    questionDesc:
      'હવે તમારા પ્રેક્ષકો તમને પ્રશ્નો પૂછી શકે છે, અને જ્યારે તમે આ પ્રશ્નોના જવાબ આપો છો ત્યારે તમને MPoint ને જ કરવું પડશે જેથી તમે જીવંત જતા પ્રશ્નાવલિની શ્રેણી પસંદ કરી શકો. તે પછી તમારા પ્રેક્ષકોને તમને પ્રશ્નો પૂછવાની તક મળશે અને તમે તેના માટે તમારા MPoint પણ મુકત કરી શકો છો.',
    Questionare: 'પ્રશ્નાવલી',
    questionasked: 'તમે પૂછેલા જૂના પ્રશ્નો',
    category: {
      // money91: "પૈસા91",
      questionary: 'પ્રશ્નાવલી',
      shopping: 'શોપિંગ'
      // love: "પ્રેમ",
      // poetry: "કવિતા",
      // politics: "રાજકારણ",
      // religious: "ધાર્મિક",
      // others: "અન્ય"
    },
    categoryNew: {
      // money91: {
      //   name: "પૈસા91",
      //   paragraph: ""
      // },
      questionary: {
        name: 'પ્રશ્નાવલી',
        paragraph:
          'બ્રોડકાસ્ટરને એક પ્રશ્ન પૂછો અને તેને ઇમૅક્સ અથવા વૉલેટમાં ટીપ આપો અથવા આ કૅટેગરી સાથે સ્વયં રહો અને તમારા પ્રેક્ષકોના પ્રશ્નોનો જવાબ આપો અને પૈસા કમાવો.'
      },
      shopping: {
        name: 'શોપિંગ',
        paragraph:
          'મૉલ 91 ના ઉત્પાદનોની લાઇવ વિડિઓ જુઓ કે જેણે તેમને ખરીદ્યું છે અથવા તેમના પોતાના પર જવું છે. તમે તમારા ખરીદેલા ઉત્પાદનોમાંથી વધુ કમાઈ શકો છો, જો કોઈ તમારા લાઇવમાંથી તે ઉત્પાદન ખરીદે છે.'
      }
    },
    goLive: 'જીવંત જાઓ',
    whichtopic: 'કયા વિષય પર',
    talkabout: 'શું તમે વાત કરો છો?',
    rules: 'નિયમો અને શરતો',
    togolive: 'જીવંત જવાનું',
    rule1:
      'જીવંત રહેવા માટે તમારી પાસે 100 થી વધુ અથવા 100 થી વધુ અનુયાયીઓ હોવા આવશ્યક છે',
    rule2:
      'જો તમે વાંધાજનક લાઇવ કરો છો તો તમે મની 9 1 થી કાયમી ધોરણે પ્રતિબંધિત થઈ શકો છો',
    rule3:
      'અનુચિત વર્તણૂંક અથવા જાતીય અને હિંસક સામગ્રીના પરિણામે તમારું એકાઉન્ટ પ્રતિબંધિત થઈ શકે છે અને કાયદા અમલીકરણ અધિકારીઓને સૂચિત કરી શકાય છે.',
    rule4:
      'તમે જે અનુભવો શેર કરો છો તેના દ્વારા અમે તમારા સંબંધોને મજબૂત બનાવવા માંગીએ છીએ, જેની તમે ખરેખર કાળજી રાખો છો. તેથી જ અમે સિસ્ટમ્સ બનાવીએ છીએ જે તમે અને અન્ય લોકો શું કાળજી લે છે તે સમજવાનો પ્રયાસ કરે છે, અને તે માહિતી તમને તે અનુભવો બનાવવા, શોધવામાં, જોડાવા અને શેર કરવામાં સહાય કરે છે.',
    rule5:
      'અમે તમારી સામગ્રીની માલિકીનો દાવો કરતા નથી, પરંતુ તમે અમને તેનો ઉપયોગ કરવાની લાઇસેંસ આપો છો.',
    rule6: 'અમે આશા રાખીએ છીએ કે તમારો અનુભવ મની 91 લાઇવ પર અનુકૂળ છે.',
    back: 'પાછા જાઓ',
    stop: 'બંધ',
    doyou: 'શું તમે કરવા માંગો છો',
    out: 'જીવંત બહાર',
    yes: 'હા',
    no: 'ના',
    follow: 'અનુસરો',
    following: 'અનુસરી રહ્યા છે',
    ifuliketalent:
      'જો તમને મારી પ્રતિભા ગમે છે તો તમે મને ભેટ સાથે પ્રોત્સાહિત કરી શકો છો',
    give: 'આપો',
    givereward: 'પુરસ્કાર આપો',
    writequestion: 'તમારો પ્રશ્ન લખો',
    whattogiveforquestion:
      'તમારે તમારા પ્રશ્નનો જવાબ આપવા માટે વૉલેટ અથવા એમ કેશ તરીકે ચુકવણી કરવી પડશે.',
    writequeshere: 'તમારો પ્રશ્ન અહીં લખો',
    continue: 'ચાલુ રાખો',
    payforques: 'તમારા પ્રશ્ન માટે ચૂકવણી કરો',
    yourques: 'તમારો પ્રશ્ન છે',
    topay: 'ચુકવણી કરો',
    questiontobeanswer: 'જવાબ આપવા માટેનો નવો પ્રશ્ન',
    answeredquestion: 'જવાબ આપ્યો',
    startchat: 'વાતચીત શરૂ કરો',
    noquestion: 'તમારી પાસે જવાબ આપવા માટે કોઈ પ્રશ્નો નથી.',
    netSlow:
      'તમારી ઇન્ટરનેટ ગતિ ધીમી છે તમારો પ્રભાવ પ્રભાવ અસરકારક થઈ શકે છે.',
    startNet: 'કૃપા કરીને તમારું ઇન્ટરનેટ કનેક્શન પ્રારંભ કરો',
    upgradeApp:
      'કૃપા કરીને આ સુવિધાનો ઉપયોગ કરવા માટે એપ્લિકેશનને અપગ્રેડ કરો.',
    appId: 'પ્રથમ એપ્લિકેશન આઈડી મેળવો!',
    startCamera:
      'કૃપા કરીને બ્રોડકાસ્ટિંગ પ્રારંભ કરવા માટે ને ક Cameraમેરા અને સ્ટોરેજને ક્સેસ કરવાની મંજૂરી આપો.',
    broadcastKicked: 'પ્રસારણકર્તાએ તમને ઓરડામાંથી બહાર કા .્યો.',
    plzchat: 'ચેટ શરૂ કરો',
    liveItem: 'રહેવા માટે આઇટમ પસંદ કરો',
    changecategory: 'તમારી કેટેગરી બદલો',
    CallingYou: 'તમને કલ કરી રહ્યું છે ...',
    For: 'માટે',
    MPointGiveYou: 'યુ.પી.પોઇન્ટ',
    accountMayBlock:
      'અયોગ્ય વર્તન અથવા જાતીય અને હિંસક સામગ્રીના પરિણામ રૂપે તમારા એકાઉન્ટ પર પ્રતિબંધ મૂકવામાં આવી શકે છે અને કાયદા અમલીકરણ અધિકારીઓને રિપોર્ટ કરવામાં આવશે.',
    writeComment: 'કૃપા કરીને પ્રથમ ટિપ્પણી લખો!',
    addedQues: 'એક નવો પ્રશ્ન ઉમેર્યો છે',
    CallDND: 'પર કલ કરો',
    CallBusy: 'વ્યસ્ત કલ કરો',
    Openlink: 'લિંક ખોલો',
    Wallet: 'વૉલેટ',
    CallingggYou: 'તમે ક લ કરી રહ્યાં છો ...',
    reportPost:
      'આ પોસ્ટની જાણ કરવા બદલ આભાર. અમે તમારો પ્રતિસાદ રેકોર્ડ કર્યો છે.',
    noWallet: 'પાકીટ નહીં રોકડ',
    Kindlyaskquestion: 'કૃપા કરીને પ્રશ્ન પૂછો.',
    wentwrong: 'કંઈક ખોટું થયું',
    serverNotRespo: 'સર્વર જવાબ નથી',
    IncreaseMPoint: 'સાંસદ વધારો',
    submitedques: 'તમારો પ્રશ્ન સફળતાપૂર્વક સબમિટ થયો છે.',
    Nobalance: 'કોઈ સંતુલન નહીં',
    liveEnded: 'જીવંત અંત આવ્યો છે.',
    sellYourProduct: 'તમારું ઉત્પાદન વેચો',
    inspireViewer: 'આઇટમ્સ ખરીદવા માટે તમારા દર્શકને પ્રેરણા આપો',
    earnOnClick: 'દરેક ક્લિક / વેચાણ પર મળ્યું',
    earnMPoint: 'દરેક ક્લિક પર સાંસદ મેળવો, અને આઇટમ વેચાણ દીઠ 30% સુધી કમાઓ',
    clickToliveItem: 'એક ક્લિક સાથે જીવંત વસ્તુ',
    boughtthisdeal: 'લોકોએ આ સોદો ખરીદ્યો છે',
    saleprice: 'વેચાણ કિંમત:',
    makeLive: 'લાઇવ બનાવો',
    noProduct: 'તમારી પાસે કોઈ ઉત્પાદન નથી',
    MoreItem: 'વધુ વસ્તુ',
    Close: 'બંધ',
    Position: 'સ્થિતિ',
    NameName: 'નામ',
    DurationTime: 'અવધિનો સમય',
    Score: 'સ્કોર',
    WINrupees: 'વિન ₹ 10000',
    EventEnd: 'ઇવેન્ટ સમાપ્ત',
    buyNow: 'હમણાં જ ખરીદો'
  },
  hi: {
    hearttoheart: 'दिल से दिल की बातें',
    showyourtalent: 'लोगों के संग।',
    withPeople: 'टैलेंट दिखाएं और MPoints कमायें।',
    hearttoheart2: 'लाइव जाएं अपने',
    withPeople2: 'पसंदीदा उत्पाद के साथ',
    showyourtalent2: 'और पैसा बनाएं',
    whatsnew: 'नया क्या है',
    callingTitle: 'कॉलिंग',
    callingDesc:
      'अब MPoints द्वारा अपने पसंदीदा प्रसारक को कॉल करें। (30 सेकंड से कम कॉल पर MPoints उपलब्ध नहीं होगा।)',
    heartTitle: 'दिल भेजें',
    heartDesc:
      'ब्रॉडकास्टर की वीडियो पर टैप करें और भेजें हार्ट ब्रॉडकास्टर को।',
    ShoppingTitle: 'खरीदारी',
    shoppingDesc:
      'अपने ख़रीदे हुए सामान के साथ लाइव जाएं और अगर कोई आपके लाइव प्रोडक्ट लिंक से खरीदता है तो आपको मिलेगा बोनस।',
    questionTitle: 'प्रश्नावली ',
    questionDesc:
      'अब आपके दर्शक पूछ सकते हैं आपसे सवाल,और इन प्रश्न के जवाब देने पर आपको मिलेंगे MPoints। बस आपको इतना करना है की लाइव जाते समय प्रश्नावली केटेगरी को सेलेक्ट करें। उसके बाद आपके दर्शको को मिलेगा आपसे सवाल पूछने का मौका और आपको MPoints, वह भी मुफ्त में।',
    Questionare: 'प्रश्नावली',
    questionasked: 'आपके पूछे गए पुराने प्रश्न',
    category: {
      // money91: "मनी९१",
      questionary: 'प्रश्नावली',
      shopping: 'खरीदारी'
      // love: "लव",
      // poetry: "शायरी",
      // politics: "राजनीति",
      // religious: "धार्मिक",
      // others: "अन्य"
    },
    categoryNew: {
      // money91: {
      //   name: "मनी९१",
      //   paragraph:
      //     "लाइव जाए और बनाये नए दोस्त या  अपना टैलेंट दिखाए और कमाए टिप्स।"
      // },
      questionary: {
        name: 'प्रश्नावली',
        paragraph:
          'ब्रॉडकास्टर से प्रश्न पूछें और उन्हें MPoints या वॉलेट राशि में टिप दें। यां खुद इस केटेगरी के साथ लाइव जाएं और अपने दर्शकों के सवालों का जवाब दें और कमाए वॉलेट यान MPoints।'
      },
      shopping: {
        name: 'खरीदारी',
        paragraph:
          'देखे मॉल91 के प्रोडक्ट्स की लाइव वीडियो उनसे जिन्होंने उन्हें ख़रीदा है यां खुद लाइव जाएं अपने ख़रीदे हुए प्रोडक्ट्स से और कमाएं कमीशन यदि कोई आपके लाइव प्रोडक्ट लिंक से वह प्रोडक्ट खरीदता है।'
      }
    },
    goLive: 'लाइव जाएँ',
    whichtopic: 'किस विषय पर ',
    talkabout: 'आप बात करेंगे?',
    rules: 'लाइव जाने के',
    togolive: 'नियम और शर्तें ',
    rule1: 'लाइव जाने क लिए आपके 100 या 100 से ज्यादा फोल्लोवेर्स होने चाहिए।',
    rule2:
      'आपत्तिजनक लाइव करने पर आपको हमेशा के लिए Mall91 से बैन किया जा सकता है।',
    rule3:
      'अनुचित व्यवहार या यौन और हिंसक सामग्री के परिणामस्वरूप आपके खाते को प्रतिबंधित किया जा सकता है और कानून प्रवर्तन अधिकारियों को सूचित किया जा सकता है।',
    rule4:
      'हम आपके द्वारा साझा किए गए अनुभवों के माध्यम से आपके रिश्तों को मजबूत करना चाहते हैं, जिनकी आप वास्तव में परवाह करते हैं। इसलिए हम उन प्रणालियों का निर्माण करते हैं जो यह समझने की कोशिश करते हैं कि आप और अन्य लोग किसके बारे में परवाह करते हैं, और उस जानकारी का उपयोग आपको उन अनुभवों को बनाने, खोजने, जुड़ने और साझा करने में मदद करते हैं।',
    rule5:
      'हम आपकी सामग्री के स्वामित्व का दावा नहीं करते हैं, लेकिन आप हमें इसका उपयोग करने का अनुज्ञप्ति देते हैं।',
    rule6: 'हम आशा करते है Mall91 लाइव पे आपका अनुभव अनुकूल रहे।',
    back: 'पीछे जाएँ ',
    stop: 'बंद करें ',
    doyou: 'क्या आप करना चाहते हैं',
    out: 'को लाइव से बाहर',
    yes: 'हाँ',
    no: 'नहीं',
    follow: 'फॉलो करें',
    following: 'फॉलो कर रहे हैं ',
    ifuliketalent:
      'यदि आपको मेरा टैलेंट पसंद है तो आप मुझे उपहार के साथ प्रोत्साहित कर सकते हैं',
    give: 'दें',
    givereward: 'इनाम दें',
    writequestion: 'अपना प्रश्न लिखें ',
    whattogiveforquestion:
      'आपको अपने प्रश्न उत्तर के लिए वॉलेट या MPoints के रूप में भुगतान करना है।',
    writequeshere: 'अपना प्रश्न यहाँ लिखें',
    continue: 'जारी रखें',
    payforques: 'अपने प्रश्न के लिए भुगतान करें',
    yourques: 'आपका प्रश्न है ',
    topay: 'भुगतान करें ',
    questiontobeanswer: 'नए प्रश्न जिसका उत्तर देना है',
    answeredquestion: 'उत्तर  दिया गया',
    startchat: 'बातचीत शुरू कीजिए',
    noquestion: 'आपके पास उत्तर देने के लिए कोई प्रश्न नहीं है।',
    netSlow: 'आपकी इंटरनेट की गति धीमी है आपका लाइव अनुभव प्रभावी हो सकता है।',
    startNet: 'कृपया अपना इंटरनेट कनेक्शन शुरू करें',
    upgradeApp: 'कृपया इस सुविधा का उपयोग करने के लिए ऐप को अपग्रेड करें।',
    appId: 'पहले ऐप आईडी प्राप्त करें!',
    startCamera:
      'कृपया प्रसारण शुरू करने के लिए गो लाइव को कैमरा और स्टोरेज एक्सेस करने दें।',
    broadcastKicked: 'ब्रॉडकास्टर ने आपको रूम से बाहर निकाल दिया है।',
    plzchat: 'चैट करें',
    liveItem: 'आइटम को लाइव करने के लिए सेलेक्ट करे',
    changecategory: 'अपनी श्रेणी बदलें',
    CallingYou: 'आपको कॉल कर रहा है ...',
    For: 'फॉर',
    MPointGiveYou: 'MPoint आपको मिलेगा',
    accountMayBlock:
      'अनुचित व्यवहार या यौन और हिंसक सामग्री के परिणामस्वरूप आपके खाते को प्रतिबंधित किया जा सकता है और कानून प्रवर्तन अधिकारियों को सूचित किया जा सकता है।',
    writeComment: 'कृपया कॉमेंट पहले लिखें!',
    addedQues: 'नया प्रश्न जोड़ा गया है|',
    CallDND: 'कॉल डी एन डी ',
    CallBusy: 'कॉल व्यस्त',
    Openlink: 'लिंक खोलें',
    Wallet: 'वॉलेट ',
    CallingggYou: 'आप कॉल कर रहे है...',
    reportPost:
      'इस पोस्ट को रिपोर्ट करने के लिए धन्यवाद।  हमने आपकी प्रतिकिर्या रिकॉर्ड करली है।',
    noWallet: 'नो वॉलेट नो कैश',
    Kindlyaskquestion: 'कृपया सवाल पूछें',
    wentwrong: 'कुछ गलत हो गया',
    serverNotRespo: 'सर्वर जवाब नहीं दे रहा है',
    IncreaseMPoint: 'MPoint बढ़ाएँ',
    submitedques: 'आपका प्रश्न सफलतापूर्वक प्रस्तुत कर दिया गया है।',
    Nobalance: 'बैलेंस नहीं है',
    liveEnded: 'लाइव समाप्त हो गया है।',
    sellYourProduct: 'अपने प्रोडक्ट को सेल करे',
    inspireViewer: 'अपने दर्शक को आइटम खरीदने के लिए प्रेरित करें',
    earnOnClick: 'हर क्लिक/सेल पर कमाए',
    earnMPoint:
      'हर एक क्लिक पर mpoint पाये, और प्रति आइटम सेल होने पर ३०% तक कमा सकतेहै',
    clickToliveItem: 'एक क्लिक पर आइटम को लाइव करें',
    boughtthisdeal: 'लोगो ने ये सौदा ख़रीदा है',
    saleprice: 'विक्रय कीमत:',
    makeLive: 'लाइव करें',
    noProduct: 'आपके पास कोई उत्पाद नहीं है',
    MoreItem: 'अधिक आइटम',
    Close: 'बंद करे',
    Position: 'स्थान',
    NameName: 'नाम',
    DurationTime: 'समय सीमा',
    Score: 'स्कोर',
    WINrupees: 'जीतें ₹10000',
    EventEnd: 'इवेंट समाप्त',
    buyNow: 'अभी खरीदें'
  },
  kn: {
    hearttoheart: 'ಹೃದಯದಿಂದ ಹೃದಯದ ಮಾತು',
    showyourtalent: 'ಜನರೊಂದಿಗೆ ನಿಮ್ಮ ಪ್ರತಿಭೆಯನ್ನು ತೋರಿಸಿ',
    withPeople: 'ಮತ್ತು ಎಂ-ಕ್ಯಾಶ್ ಪಡೆಯಿರಿ',
    hearttoheart2: 'ಲೈವ್ ಆಗಿ ಹೋಗಿ',
    withPeople2: 'ನಿಮ್ಮ ನೆಚ್ಚಿನ ಉತ್ಪನ್ನದೊಂದಿಗೆ',
    showyourtalent2: 'ಮತ್ತು ಹಣ ಸಂಪಾದಿಸಿ',
    whatsnew: 'ಹೊಸತೇನಿದೆ',
    callingTitle: 'ಕರೆ ಮಾಡಲಾಗುತ್ತಿದೆ',
    callingDesc:
      'ಈಗ ನಿಮ್ಮ ನೆಚ್ಚಿನ ಬ್ರಾಡ್‌ಕಾಸ್ಟರ್ ಅನ್ನು MPoint ನಿಂದ ಕರೆ ಮಾಡಿ. (30 ಸೆಕೆಂಡುಗಳಿಗಿಂತ ಕಡಿಮೆ ಕರೆಗಳಲ್ಲಿ MPoint ಲಭ್ಯವಿರುವುದಿಲ್ಲ.)',
    heartTitle: 'ಹೃದಯವನ್ನು ಕಳುಹಿಸಿ',
    heartDesc:
      'ಬ್ರಾಡ್‌ಕಾಸ್ಟರ್‌ನ ವೀಡಿಯೊದಲ್ಲಿ ಹಾರ್ಟ್ಸ್ ಲೈವ್ ಅನ್ನು ಟ್ಯಾಪ್ ಮಾಡಿ ಮತ್ತು ಹಾರ್ಟ್ಸ್ ಬ್ರಾಡ್‌ಕಾಸ್ಟರ್‌ಗೆ ಕಳುಹಿಸಿ',
    ShoppingTitle: 'ಖರೀದಿ',
    shoppingDesc:
      'ಮಾಲ್ 91 ರಿಂದ ಖರೀದಿಸಿದ ಸರಕುಗಳಿಂದ ಲೈವ್ ಸರಕುಗಳು ಮತ್ತು ಲೈವ್ ರೆಫರಲ್‌ಗಳ ಹಣ. ನೀವು ಖರೀದಿಸಿದ ಐಟಂನೊಂದಿಗೆ ಲೈವ್ ಆಗಿ ಹೋಗಿ ಮತ್ತು ಯಾರಾದರೂ ನಿಮ್ಮನ್ನು ಲೈವ್ ಆಗಿ ಖರೀದಿಸಿದರೆ ನಿಮಗೆ ಬೋನಸ್ ಸಿಗುತ್ತದೆ.',
    questionTitle: 'ಪ್ರಶ್ನಾವಳಿ ',
    questionDesc:
      'ಈಗ ನಿಮ್ಮ ಪ್ರೇಕ್ಷಕರು ನಿಮಗೆ ಪ್ರಶ್ನೆಗಳನ್ನು ಕೇಳಬಹುದು, ಮತ್ತು ನೀವು ಈ ಪ್ರಶ್ನೆಗಳಿಗೆ ಉತ್ತರಿಸುವಾಗ ನೀವು MPoint ಅನ್ನು ಪಡೆಯಬೇಕು ಆದ್ದರಿಂದ ನೀವು ಲೈವ್‌ಗೆ ಹೋಗುವಾಗ ಪ್ರಶ್ನಾವಳಿಯ ವರ್ಗವನ್ನು ಆಯ್ಕೆ ಮಾಡಬಹುದು. ಅದರ ನಂತರ ನಿಮ್ಮ ಪ್ರೇಕ್ಷಕರು ನಿಮಗೆ ಪ್ರಶ್ನೆಗಳನ್ನು ಕೇಳುವ ಅವಕಾಶವನ್ನು ಪಡೆಯುತ್ತಾರೆ ಮತ್ತು ಅದಕ್ಕಾಗಿ ನಿಮ್ಮ MPoint ಅನ್ನು ಸಹ ನೀವು ಮುಕ್ತಗೊಳಿಸಬಹುದು.',
    Questionare: 'ಪ್ರಶ್ನಾವಳಿ',
    questionasked: 'ನೀವು ಕೇಳಿದ ಹಳೆಯ ಪ್ರಶ್ನೆಗಳು',
    category: {
      // money91: "ಹಣ91",
      questionary: 'ಪ್ರಶ್ನಾವಳಿ',
      shopping: 'ಶಾಪಿಂಗ್'
      // love: "ಲವ್",
      // poetry: "ಕವನ",
      // politics: "ರಾಜಕೀಯ",
      // religious: "ಧಾರ್ಮಿಕ",
      // others: "ಇತರರು"
    },
    categoryNew: {
      // money91: {
      //   name: "ಹಣ91",
      //   paragraph:
      //     "ನೇರ ಪ್ರಸಾರ ಮಾಡಿ ಮತ್ತು ಹೊಸ ಸ್ನೇಹಿತರನ್ನು ಅಥವಾ ನಿಮ್ಮ ಪ್ರತಿಭೆಯನ್ನು ತೋರಿಸಿ ಮತ್ತು ಸುಳಿವುಗಳನ್ನು ಸಂಪಾದಿಸಿ."
      // },
      questionary: {
        name: 'ಪ್ರಶ್ನಾವಳಿ',
        paragraph:
          'ಪ್ರಸಾರಕರಿಗೆ ಪ್ರಶ್ನೆಯನ್ನು ಕೇಳಿ ಮತ್ತು ಅವನಿಗೆ ಇಮಾಕ್ಸ್ ಅಥವಾ ವ್ಯಾಲೆಟ್ನಲ್ಲಿ ಒಂದು ತುದಿ ನೀಡಿ ಅಥವಾ ಈ ವರ್ಗದೊಂದಿಗೆ ನೀವೇ ಲೈವ್ ಆಗಿ ಹೋಗಿ ಮತ್ತು ನಿಮ್ಮ ಪ್ರೇಕ್ಷಕರ ಪ್ರಶ್ನೆಗಳಿಗೆ ಉತ್ತರಿಸಿ ಮತ್ತು ಹಣವನ್ನು ಸಂಪಾದಿಸಿ.'
      },
      shopping: {
        name: 'ಶಾಪಿಂಗ್',
        paragraph:
          'ಮಾಲ್ 91 ರ ಉತ್ಪನ್ನಗಳನ್ನು ಖರೀದಿಸಿದವರಿಂದ ಅಥವಾ ಸ್ವಂತವಾಗಿ ಲೈವ್ ಆಗಿ ಹೋದವರ ಲೈವ್ ವೀಡಿಯೊವನ್ನು ನೋಡಿ.ನಿಮ್ಮ ಲೈವ್‌ನಿಂದ ಯಾರಾದರೂ ಆ ಉತ್ಪನ್ನವನ್ನು ಖರೀದಿಸಿದರೆ ನೀವು ಖರೀದಿಸಿದ ಉತ್ಪನ್ನಗಳಿಂದ ನೀವು ಹೆಚ್ಚು ಸಂಪಾದಿಸುತ್ತೀರಿ.'
      }
    },
    goLive: 'જાઓ જીવંત',
    whichtopic: 'ಯಾವ ವಿಷಯದ ಮೇಲೆ',
    talkabout: 'ನೀವು ಬಗ್ಗೆ ಮಾತನಾಡುತ್ತೀರಾ?',
    rules: 'ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು',
    togolive: 'ಲೈವ್ ಹೋಗುವ',
    rule1:
      'ನೀವು 100 ಕ್ಕಿಂತ ಹೆಚ್ಚು ಅಥವಾ 100 ಕ್ಕಿಂತ ಹೆಚ್ಚು ಅನುಯಾಯಿಗಳು ಲೈವ್ ಆಗಿ ಹೋಗಲು ಹೊಂದಿರಬೇಕು',
    rule2:
      'ನೀವು ಆಕ್ಷೇಪಾರ್ಹ ಲೈವ್ ಅನ್ನು ಮಾಡುತ್ತಿದ್ದರೆ ನೀವು ಶಾಶ್ವತವಾಗಿ Money91 ನಿಂದ ನಿಷೇಧಿಸಬಹುದಾಗಿದೆ',
    rule3:
      'ಸೂಕ್ತವಲ್ಲದ ನಡವಳಿಕೆ ಅಥವಾ ಲೈಂಗಿಕ ಮತ್ತು ಹಿಂಸಾತ್ಮಕ ವಿಷಯವು ನಿಮ್ಮ ಖಾತೆಯನ್ನು ನಿಷೇಧಿಸಲಾಗಿದೆ ಮತ್ತು ಕಾನೂನು ಜಾರಿ ಅಧಿಕಾರಿಗಳಿಗೆ ಸೂಚನೆ ನೀಡಬಹುದು.',
    rule4:
      'ನೀವು ಹಂಚಿಕೊಳ್ಳುವ ಅನುಭವಗಳ ಮೂಲಕ ನಿಮ್ಮ ಸಂಬಂಧಗಳನ್ನು ಬಲಪಡಿಸಲು ನಾವು ಬಯಸುತ್ತೇವೆ. ಅದಕ್ಕಾಗಿಯೇ ನೀವು ಮತ್ತು ಇತರರು ಏನು ಕಾಳಜಿ ವಹಿಸುತ್ತೀರಿ ಎಂಬುದನ್ನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳಲು ಪ್ರಯತ್ನಿಸುವಂತಹ ವ್ಯವಸ್ಥೆಗಳನ್ನು ನಾವು ರಚಿಸುತ್ತೇವೆ ಮತ್ತು ಆ ಅನುಭವಗಳನ್ನು ರಚಿಸಲು, ಅನ್ವೇಷಿಸಲು, ಸೇರಲು ಮತ್ತು ಹಂಚಿಕೊಳ್ಳಲು ಅದು ಸಹಾಯ ಮಾಡುತ್ತದೆ.',
    rule5:
      'ನಿಮ್ಮ ವಿಷಯದ ಮಾಲೀಕತ್ವವನ್ನು ನಾವು ಹಕ್ಕು ಪಡೆಯುವುದಿಲ್ಲ, ಆದರೆ ಅದನ್ನು ಬಳಸಲು ನಾವು ನಮಗೆ ಪರವಾನಗಿ ನೀಡಿದ್ದೇವೆ.',
    rule6:
      'Money91 Live ನಲ್ಲಿ ನಿಮ್ಮ ಅನುಭವವು ಅನುಕೂಲಕರವಾಗಿದೆ ಎಂದು ನಾವು ಭಾವಿಸುತ್ತೇವೆ.',
    back: 'ಹಿಂತಿರುಗಿ',
    stop: 'ನಿಲ್ಲಿಸಿ',
    doyou: 'ನೀವು ಏನು ಮಾಡಬೇಕೆಂದು ಬಯಸುತ್ತೀರಿ',
    out: 'ಲೈವ್ ಔಟ್',
    yes: 'ಹೌದು',
    no: 'ಇಲ್ಲ',
    follow: 'ಅನುಸರಿಸಿ',
    following: 'ಅನುಸರಿಸುತ್ತಿವೆ',
    ifuliketalent:
      'ನೀವು ನನ್ನ ಪ್ರತಿಭೆಯನ್ನು ಬಯಸಿದರೆ ನೀವು ನನ್ನನ್ನು ಉಡುಗೊರೆಯಾಗಿ ಪ್ರೋತ್ಸಾಹಿಸಬಹುದು',
    give: 'ಅದನ್ನು ನೀಡಿ',
    givereward: 'ರಿವಾರ್ಡ್ ನೀಡಿ',
    writequestion: 'ನಿಮ್ಮ ಪ್ರಶ್ನೆಯನ್ನು ಬರೆಯಿರಿ',
    whattogiveforquestion:
      'ನಿಮ್ಮ ಪ್ರಶ್ನೆಯ ಉತ್ತರಕ್ಕಾಗಿ ನೀವು ವಾಲೆಟ್ ಅಥವಾ ಎಂ ಕ್ಯಾಶ್ ಆಗಿ ಪಾವತಿಸಬೇಕು.',
    writequeshere: 'ನಿಮ್ಮ ಪ್ರಶ್ನೆಯನ್ನು ಇಲ್ಲಿ ಬರೆಯಿರಿ',
    continue: 'ಮುಂದುವರಿಸಿ',
    payforques: 'ನಿಮ್ಮ ಪ್ರಶ್ನೆಗೆ ಪಾವತಿಸಿ',
    yourques: 'ನಿಮ್ಮ ಪ್ರಶ್ನೆ',
    topay: 'ಪಾವತಿಸಿ',
    questiontobeanswer: 'ಉತ್ತರಿಸಲು ಹೊಸ ಪ್ರಶ್ನೆ',
    answeredquestion: 'ಉತ್ತರ',
    startchat: 'ಸಂವಾದವನ್ನು ಪ್ರಾರಂಭಿಸಿ',
    noquestion: 'ನಿಮಗೆ ಉತ್ತರಿಸಲು ಯಾವುದೇ ಪ್ರಶ್ನೆಗಳಿಲ್ಲ.',
    netSlow:
      'youನಿಮ್ಮ ಇಂಟರ್ನೆಟ್ ವೇಗ ನಿಧಾನವಾಗಿದೆ ನಿಮ್ಮ ಗೋಲಿವ್ ಅನುಭವವು ಪರಿಣಾಮ ಬೀರಬಹುದು.',
    startNet: 'ದಯವಿಟ್ಟು ನಿಮ್ಮ ಇಂಟರ್ನೆಟ್ ಸಂಪರ್ಕವನ್ನು ಪ್ರಾರಂಭಿಸಿ',
    upgradeApp:
      'ಈ ವೈಶಿಷ್ಟ್ಯವನ್ನು ಬಳಸಲು ದಯವಿಟ್ಟು ಅಪ್ಲಿಕೇಶನ್ ಅನ್ನು ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ.',
    appId: 'ಮೊದಲು ಅಪ್ಲಿಕೇಶನ್ ಐಡಿ ಪಡೆಯಿರಿ!',
    startCamera:
      'ಪ್ರಸಾರವನ್ನು ಪ್ರಾರಂಭಿಸಲು ಕ್ಯಾಮೆರಾ ಮತ್ತು ಸಂಗ್ರಹಣೆಯನ್ನು ಪ್ರವೇಶಿಸಲು ದಯವಿಟ್ಟು ಗೋಲೈವ್ ಅನ್ನು ಅನುಮತಿಸಿ.',
    broadcastKicked: 'ಪ್ರಸಾರಕರು ನಿಮ್ಮನ್ನು ಕೋಣೆಯಿಂದ ಹೊರಗೆ ಹಾಕಿದರು.',
    plzchat: 'ಚಾಟ್ ಪ್ರಾರಂಭಿಸಿ',
    liveItem: 'ವಾಸಿಸಲು ಐಟಂ ಆಯ್ಕೆಮಾಡಿ',
    changecategory: 'ನಿಮ್ಮ ವರ್ಗವನ್ನು ಬದಲಾಯಿಸಿ',
    CallingYou: 'ನಿನ್ನನ್ನು ಕರೆಯುತ್ತಿದ್ದೇನೆ...',
    For: 'ಫಾರ್',
    MPointGiveYou: 'ಎಂಪಾಯಿಂಟ್ ನಿಮಗೆ ನೀಡಿ',
    accountMayBlock:
      'ಅನುಚಿತ ವರ್ತನೆ ಅಥವಾ ಲೈಂಗಿಕ ಮತ್ತು ಹಿಂಸಾತ್ಮಕ ವಿಷಯವು ನಿಮ್ಮ ಖಾತೆಯನ್ನು ನಿಷೇಧಿಸಲು ಮತ್ತು ಕಾನೂನು ಜಾರಿ ಅಧಿಕಾರಿಗಳಿಗೆ ವರದಿ ಮಾಡಲು ಕಾರಣವಾಗಬಹುದು.',
    writeComment: 'ದಯವಿಟ್ಟು ಮೊದಲು ಕಾಮೆಂಟ್ ಬರೆಯಿರಿ!',
    addedQues: 'ಹೊಸ ಪ್ರಶ್ನೆಯನ್ನು ಸೇರಿಸಲಾಗಿದೆ',
    CallDND: 'ಡಿಎನ್‌ಡಿಗೆ ಕರೆ ಮಾಡಿ',
    CallBusy: 'ಬ್ಯುಸಿ ಎಂದು ಕರೆ ಮಾಡಿ',
    Openlink: 'ಲಿಂಕ್ ತೆರೆಯಿರಿ',
    Wallet: 'ವಾಲೆಟ್',
    CallingggYou: 'ನೀವು ಕರೆ ಮಾಡುತ್ತಿದ್ದೀರಿ ...',
    reportPost:
      'ಈ ಪೋಸ್ಟ್ ಅನ್ನು ವರದಿ ಮಾಡಿದ್ದಕ್ಕಾಗಿ ಧನ್ಯವಾದಗಳು. ನಿಮ್ಮ ಪ್ರತಿಕ್ರಿಯೆಯನ್ನು ನಾವು ದಾಖಲಿಸಿದ್ದೇವೆ.',
    noWallet: 'ಯಾವುದೇ ಕೈಚೀಲ ಇಲ್ಲ ನಗದು',
    Kindlyaskquestion: 'ದಯವಿಟ್ಟು ಪ್ರಶ್ನೆ ಕೇಳಿ.',
    wentwrong: 'ಏನೋ ತಪ್ಪಾಗಿದೆ',
    serverNotRespo: 'ಸರ್ವರ್ ಪ್ರತಿಕ್ರಿಯಿಸುತ್ತಿಲ್ಲ',
    IncreaseMPoint: 'ಎಂಪಾಯಿಂಟ್ ಹೆಚ್ಚಿಸಿ',
    submitedques: 'ನಿಮ್ಮ ಪ್ರಶ್ನೆಯನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಸಲ್ಲಿಸಲಾಗಿದೆ.',
    Nobalance: 'ಸಮತೋಲನವಿಲ್ಲ',
    liveEnded: 'ಲೈವ್ ಕೊನೆಗೊಂಡಿದೆ.',
    sellYourProduct: 'ನಿಮ್ಮ ಉತ್ಪನ್ನವನ್ನು ಮಾರಾಟ ಮಾಡಿ',
    inspireViewer: 'ವಸ್ತುಗಳನ್ನು ಖರೀದಿಸಲು ನಿಮ್ಮ ವೀಕ್ಷಕರನ್ನು ಪ್ರೇರೇಪಿಸಿ',
    earnOnClick: 'ಪ್ರತಿ ಕ್ಲಿಕ್ / ಮಾರಾಟದಲ್ಲಿ ಗಳಿಸಲಾಗಿದೆ',
    earnMPoint:
      'ಪ್ರತಿ ಕ್ಲಿಕ್‌ನಲ್ಲಿ ಎಂಪಾಯಿಂಟ್ ಪಡೆಯಿರಿ ಮತ್ತು ಪ್ರತಿ ಐಟಂ ಮಾರಾಟಕ್ಕೆ 30% ವರೆಗೆ ಸಂಪಾದಿಸಿ',
    clickToliveItem: 'ಒಂದೇ ಕ್ಲಿಕ್‌ನಲ್ಲಿ ಲೈವ್ ಐಟಂ',
    boughtthisdeal: 'ಜನರು ಈ ಒಪ್ಪಂದವನ್ನು ಖರೀದಿಸಿದ್ದಾರೆ',
    saleprice: 'ಮಾರಾಟ ಬೆಲೆ:',
    makeLive: 'ಲೈವ್ ಮಾಡಿ',
    noProduct: 'ನೀವು ಯಾವುದೇ ಉತ್ಪನ್ನವನ್ನು ಹೊಂದಿಲ್ಲ',
    MoreItem: 'ಇನ್ನಷ್ಟು ಐಟಂ',
    Close: 'ಮುಚ್ಚಿ',
    Position: 'ಸ್ಥಾನ',
    NameName: 'ಹೆಸರು',
    DurationTime: 'ಅವಧಿ ಸಮಯ',
    Score: 'ಸ್ಕೋರ್',
    WINrupees: 'ವಿನ್ ₹ 10000',
    EventEnd: 'ಈವೆಂಟ್ ಎಂಡ್',
    buyNow: 'ಈಗ ಖರೀದಿಸು'
  },
  ml: {
    hearttoheart: 'ഹൃദയത്തിൽ നിന്ന് സംസാരിക്കുക',
    showyourtalent: 'ആളുകളുമായി നിങ്ങളുടെ കഴിവുകൾ കാണിക്കുക',
    withPeople: 'എം-ക്യാഷ് നേടുക',
    hearttoheart2: 'തത്സമയം',
    withPeople2: 'നിങ്ങളുടെ പ്രിയപ്പെട്ട ഉൽപ്പന്നത്തിനൊപ്പം',
    showyourtalent2: 'പണം സമ്പാദിക്കുക',
    callingTitle: 'വിളിക്കുന്നു',
    callingDesc:
      'MPoint നിങ്ങളുടെ പ്രിയപ്പെട്ട ബ്രോഡ്‌കാസ്റ്ററെ വിളിക്കുക. (30 സെക്കൻഡിൽ താഴെയുള്ള കോളുകളിൽ MPoint ലഭ്യമാകില്ല.)',
    heartTitle: 'ഹൃദയം അയയ്ക്കുക',
    heartDesc:
      'ബ്രോഡ്‌കാസ്റ്ററിന്റെ വീഡിയോയിൽ ഹാർട്ട്സ് ലൈവിൽ ടാപ്പുചെയ്‌ത് ഹാർട്ട്സ് ബ്രോഡ്‌കാസ്റ്ററിലേക്ക് അയയ്‌ക്കുക',
    whatsnew: 'പുതിയതെന്താണ്',
    ShoppingTitle: 'വാങ്ങൽ',
    shoppingDesc:
      'മാൾ 91 ൽ നിന്ന് വാങ്ങിയ സാധനങ്ങളിൽ നിന്നുള്ള തത്സമയ ചരക്കുകളും തത്സമയ റഫറലുകളും. നിങ്ങൾ വാങ്ങിയ ഇനത്തിനൊപ്പം തത്സമയം പോകുക, ആരെങ്കിലും നിങ്ങളെ തത്സമയം വാങ്ങിയാൽ നിങ്ങൾക്ക് ഒരു ബോണസ് ലഭിക്കും.',
    questionTitle: 'ചോദ്യാവലി ',
    questionDesc:
      'ഇപ്പോൾ നിങ്ങളുടെ പ്രേക്ഷകർക്ക് നിങ്ങളോട് ചോദ്യങ്ങൾ ചോദിക്കാൻ കഴിയും, നിങ്ങൾ ഈ ചോദ്യങ്ങൾക്ക് ഉത്തരം നൽകുമ്പോൾ നിങ്ങൾക്ക് MPoint ലഭിക്കും, അങ്ങനെ തത്സമയം പോകുമ്പോൾ നിങ്ങൾക്ക് ചോദ്യാവലിയുടെ വിഭാഗം തിരഞ്ഞെടുക്കാനാകും. അതിനുശേഷം നിങ്ങളുടെ പ്രേക്ഷകർക്ക് നിങ്ങളോട് ചോദ്യങ്ങൾ ചോദിക്കാനുള്ള അവസരം ലഭിക്കും, അതിനായി നിങ്ങളുടെ MPoint സ്വതന്ത്രമാക്കാനും കഴിയും.',
    Questionare: 'ചോദ്യാവലി',
    questionasked: 'നിങ്ങൾ ചോദിച്ച പഴയ ചോദ്യങ്ങൾ',
    category: {
      // money91: "പണം91",
      questionary: 'ചോദ്യാവലി',
      shopping: 'ഷോപ്പിംഗ്'
      // love: "സ്നേഹം",
      // poetry: "കവിത",
      // politics: "രാഷ്ട്രീയം",
      // religious: "മതപരമായ",
      // others: "മറ്റുള്ളവ"
    },
    categoryNew: {
      // money91: {
      //   name: "പണം91",
      //   paragraph:
      //     "തത്സമയം പോയി പുതിയ സുഹൃത്തുക്കളെയോ കഴിവുകളെയോ കാണിച്ച് നുറുങ്ങുകൾ നേടുക."
      // },
      questionary: {
        name: 'ചോദ്യാവലി',
        paragraph:
          'ബ്രോഡ്‌കാസ്റ്ററോട് ഒരു ചോദ്യം ചോദിക്കുക, അദ്ദേഹത്തിന് ഇമാക്സിലോ വാലറ്റിലോ ഒരു ടിപ്പ് നൽകുക അല്ലെങ്കിൽ ഈ വിഭാഗത്തിനൊപ്പം തത്സമയം പോയി നിങ്ങളുടെ പ്രേക്ഷക ചോദ്യങ്ങൾക്ക് ഉത്തരം നൽകി പണം സമ്പാദിക്കുക.'
      },
      shopping: {
        name: 'ഷോപ്പിംഗ്',
        paragraph:
          'ാൾ 91 ന്റെ ഉൽ‌പ്പന്നങ്ങൾ‌ വാങ്ങിയവരിൽ‌ നിന്നോ അല്ലെങ്കിൽ‌ സ്വന്തമായി തത്സമയം പോകുന്നവരിൽ‌ നിന്നോ തത്സമയ വീഡിയോ കാണുക.നിങ്ങൾ‌ തത്സമയം ആരെങ്കിലും ആ ഉൽ‌പ്പന്നം വാങ്ങിയാൽ‌ നിങ്ങൾ‌ വാങ്ങിയ ഉൽ‌പ്പന്നങ്ങളിൽ‌ നിന്നും നിങ്ങൾ‌ കൂടുതൽ‌ സമ്പാദിക്കുന്നു.'
      }
    },
    goLive: 'പോകുക തത്സമയം',
    whichtopic: 'ഏത് വിഷയത്തിലാണ്',
    talkabout: 'നിങ്ങൾ സംസാരിക്കാമോ?',
    rules: 'നയങ്ങളും നിബന്ധനകളും',
    togolive: 'തത്സമയം',
    rule1: 'നിങ്ങൾക്ക് 100 ൽ അധികം 100 പിന്തുടരുന്നവരെ തൽസമയമായി പോകേണ്ടതുണ്ട്',
    rule2:
      'നിങ്ങൾ ഒരു അധിക്ഷേപകരമായ തത്സമയമാണെങ്കിൽ Money91- ൽ നിന്ന് എന്നെന്നേയ്ക്കുമായി നിരോധിക്കാനാകും',
    rule3:
      'അനുചിതമായ സ്വഭാവം അല്ലെങ്കിൽ ലൈംഗിക അതിക്രമ ഉള്ളടക്കം നിങ്ങളുടെ അക്കൗണ്ടിനെ നിരോധിക്കുന്നതിനും നിയമ നിർവ്വഹണ അധികാരികളെ അറിയിക്കുന്നതിനും ഇടയാക്കും.',
    rule4:
      'നിങ്ങൾ പങ്കുവയ്ക്കുന്ന അനുഭവങ്ങളിലൂടെ നിങ്ങളുടെ ബന്ധത്തെ ശക്തിപ്പെടുത്താൻ ഞങ്ങൾ ആഗ്രഹിക്കുന്നു. അതിനാലാണ് നിങ്ങൾക്കും മറ്റുള്ളവർക്കും എന്താണ് വേണ്ടതെന്ന് മനസ്സിലാക്കാൻ ശ്രമിക്കുന്ന സംവിധാനങ്ങൾ നിർമ്മിക്കുന്നത്, ആ അനുഭവങ്ങൾ സൃഷ്ടിക്കാനും കണ്ടെത്തുകയും പങ്കുവെക്കാനും പങ്കുവയ്ക്കാനും ആ വിവരങ്ങൾ നിങ്ങളെ സഹായിക്കുന്നു.',
    rule5:
      'ഞങ്ങൾ നിങ്ങളുടെ ഉള്ളടക്കത്തിന്റെ ഉടമസ്ഥാവകാശം അവകാശപ്പെടില്ല, പക്ഷേ അത് ഉപയോഗിക്കാൻ ഞങ്ങൾക്ക് ലൈസൻസ് നൽകുന്നു.',
    rule6:
      'Money91 ലൈവ് എന്നതിൽ നിങ്ങളുടെ അനുഭവം അനുകൂലമാണെന്ന് ഞങ്ങൾ പ്രതീക്ഷിക്കുന്നു.',
    back: 'തിരികെ പോകുക',
    stop: 'നിർത്തുക',
    doyou: 'നിങ്ങൾക്ക് എന്താണ് ചെയ്യേണ്ടത്',
    out: 'തത്ഫലമായി',
    yes: 'അതെ',
    no: 'ഇല്ല',
    follow: 'പിന്തുടരുക',
    following: 'പിന്തുടരുന്നു',
    ifuliketalent:
      'നിങ്ങൾ എന്റെ കഴിവുകഴിയുകയാണെങ്കിൽ എനിക്കൊരു സമ്മാനം കൊണ്ട് എന്നെ പ്രോത്സാഹിപ്പിക്കാം',
    give: 'കൊടുക്കൂ',
    givereward: 'പ്രതിഫലം കൊടുക്കുക',
    writequestion: 'നിങ്ങളുടെ ചോദ്യം എഴുതുക',
    whattogiveforquestion:
      'നിങ്ങളുടെ ചോദ്യത്തിനുള്ള ഉത്തരം ഒരു വാലറ്റ് അല്ലെങ്കിൽ എം ക്യാഷ് ആയി നൽകണം.',
    writequeshere: 'ഇവിടെ നിങ്ങളുടെ ചോദ്യം എഴുതുക',
    continue: 'തുടരുക',
    payforques: 'നിങ്ങളുടെ ചോദ്യത്തിന് പണമടയ്ക്കുക',
    yourques: 'നിങ്ങളുടെ ചോദ്യം',
    topay: 'പേയ്മെന്റ് നടത്തുക',
    questiontobeanswer: 'ഉത്തരം നൽകുവാൻ പുതിയ ചോദ്യം',
    answeredquestion: 'ഉത്തരം നൽകി',
    startchat: 'സംഭാഷണം ആരംഭിക്കുക',
    noquestion: 'നിങ്ങൾക്ക് ഉത്തരം നൽകാൻ ചോദ്യങ്ങളൊന്നുമില്ല.',
    netSlow:
      'നിങ്ങളുടെ ഇന്റർനെറ്റ് വേഗത മന്ദഗതിയിലാണ് നിങ്ങളുടെ മികച്ച അനുഭവം ഫലപ്രദമാകാം.',
    startNet: 'നിങ്ങളുടെ ഇന്റർനെറ്റ് കണക്ഷൻ ആരംഭിക്കുക',
    upgradeApp: 'ഈ സവിശേഷത ഉപയോഗിക്കുന്നതിന് അപ്ലിക്കേഷൻ അപ്‌ഗ്രേഡുചെയ്യുക.',
    appId: 'ആദ്യം അപ്ലിക്കേഷൻ ഐഡി നേടുക!',
    startCamera:
      'പ്രക്ഷേപണം ആരംഭിക്കുന്നതിന് ക്യാമറയും സംഭരണവും ആക്‌സസ് ചെയ്യാൻ GoLive നെ അനുവദിക്കുക.',
    broadcastKicked: 'ബ്രോഡ്‌കാസ്റ്റർ നിങ്ങളെ മുറിയിൽ നിന്ന് പുറത്താക്കി.',
    plzchat: 'ചാറ്റ് ആരംഭിക്കുക',
    liveItem: 'തത്സമയം ഇനം തിരഞ്ഞെടുക്കുക',
    changecategory: 'നിങ്ങളുടെ വിഭാഗം മാറ്റുക',
    CallingYou: 'വിളിക്കുന്നു...',
    For: 'വേണ്ടി',
    MPointGiveYou: 'എംപോയിന്റ് തരൂ',
    accountMayBlock:
      'അനുചിതമായ പെരുമാറ്റം അല്ലെങ്കിൽ ലൈംഗികവും അക്രമപരവുമായ ഉള്ളടക്കം നിങ്ങളുടെ അക്കൗണ്ട് നിരോധിക്കുകയും നിയമ നിർവഹണ ഉദ്യോഗസ്ഥർക്ക് റിപ്പോർട്ട് ചെയ്യുകയും ചെയ്യും.',
    writeComment: 'ആദ്യം അഭിപ്രായം എഴുതുക!',
    addedQues: 'ഒരു പുതിയ ചോദ്യം ചേർത്തു',
    CallDND: 'ലേക്ക് വിളിക്കുക',
    CallBusy: 'തിരക്കിലാണ് വിളിക്കുക',
    Openlink: 'ലിങ്ക് തുറക്കുക',
    Wallet: 'വാലറ്റ്',
    CallingggYou: 'നിങ്ങൾ വിളിക്കുന്നു ...',
    reportPost:
      'ഈ പോസ്റ്റ് റിപ്പോർട്ട് ചെയ്തതിന് നന്ദി. നിങ്ങളുടെ പ്രതികരണം ഞങ്ങൾ രേഖപ്പെടുത്തി.',
    noWallet: 'വാലറ്റ് പണമില്ല',
    Kindlyaskquestion: 'ദയവായി ചോദ്യം ചോദിക്കുക.',
    wentwrong: 'എന്തോ കുഴപ്പം സംഭവിച്ചു',
    serverNotRespo: 'സെർവർ പ്രതികരിക്കുന്നില്ല',
    IncreaseMPoint: 'എംപോയിന്റ് വർദ്ധിപ്പിക്കുക',
    submitedques: 'നിങ്ങളുടെ ചോദ്യം വിജയകരമായി സമർപ്പിച്ചു.',
    Nobalance: 'ബാലൻസ് ഇല്ല',
    liveEnded: 'തത്സമയം അവസാനിച്ചു.',
    sellYourProduct: 'നിങ്ങളുടെ ഉൽപ്പന്നം വിൽക്കുക',
    inspireViewer: 'ഇനങ്ങൾ വാങ്ങാൻ നിങ്ങളുടെ കാഴ്ചക്കാരനെ പ്രേരിപ്പിക്കുക',
    earnOnClick: 'ഓരോ ക്ലിക്കിലും വിൽപ്പനയിലും സമ്പാദിച്ചു',
    earnMPoint:
      'ഓരോ ക്ലിക്കിലും എംപോയിന്റ് നേടുക, ഓരോ ഇന വിൽപ്പനയ്ക്കും 30% വരെ സമ്പാദിക്കുക',
    clickToliveItem: 'ഒരു ക്ലിക്കിലൂടെ തത്സമയ ഇനം',
    boughtthisdeal: 'ആളുകൾ ഈ ഡീൽ വാങ്ങി',
    saleprice: 'വില്പന വില:',
    makeLive: 'തത്സമയമാക്കുക',
    noProduct: 'നിങ്ങൾക്ക് ഉൽപ്പന്നമൊന്നുമില്ല',
    MoreItem: 'കൂടുതൽ ഇനം',
    Close: 'അടയ്‌ക്കുക',
    Position: 'സ്ഥാനം',
    NameName: 'പേര്',
    DurationTime: 'കാലാവധി സമയം',
    Score: 'സ്കോർ',
    WINrupees: 'വിൻ ₹ 10000',
    EventEnd: 'ഇവന്റ് അവസാനം',
    buyNow: 'ഇപ്പോൾ വാങ്ങുക'
  },
  mr: {
    hearttoheart: 'हृदयस्पर्शी बोलणे',
    showyourtalent: 'लोकांसह आपली प्रतिभा दर्शवा',
    withPeople: 'आणि एम-कॅश मिळवा',
    hearttoheart2: 'थेट जा',
    withPeople2: 'आपल्या आवडत्या उत्पादनासह',
    showyourtalent2: 'आणि पैसे कमवा',
    whatsnew: 'नवीन काय आहे',
    callingTitle: 'कॉल करीत आहे',
    callingDesc:
      'आता आपल्या आवडत्या ब्रॉडकास्टरला एमकॅशद्वारे कॉल करा. (30 सेकंदांपेक्षा कमी कॉलवर एमकॅश उपलब्ध नाहीत.)',
    heartTitle: 'हृदय पाठवा',
    heartDesc:
      'ब्रॉडकास्टरच्या व्हिडिओवरील हर्ट्स लाइव्हवर टॅप करा आणि हर्ट्स ब्रॉडकास्टर वर पाठवा',
    ShoppingTitle: 'खरेदी',
    shoppingDesc:
      'मॉल 9 1 कडून खरेदी केलेल्या सामानांमधून थेट वस्तू आणि थेट संदर्भ. आपल्या खरेदी केलेल्या आयटमसह थेट जा आणि जर कोणी आपल्याला थेट खरेदी करतो तर आपल्याला बोनस मिळेल.',
    questionTitle: 'प्रश्नावली',
    questionDesc:
      'आता आपले प्रेक्षक आपल्याला प्रश्न विचारू शकतात आणि जेव्हा आपण या प्रश्नांची उत्तरे दिलीत तेव्हा आपल्याला केवळ एमसीएएस मिळतील जेणेकरून आपण थेट जात असताना प्रश्नावलीची श्रेणी निवडू शकता. त्यानंतर आपल्या प्रेक्षकांना आपल्याला प्रश्न विचारण्याची संधी मिळेल आणि त्यासाठी आपण देखील आपल्या MPoint मोकळे करू शकता.',
    Questionare: 'प्रश्नावली',
    questionasked: 'आपण विचारलेले जुने प्रश्न',
    category: {
      // money91: "पैसा91",
      questionary: 'प्रश्नावली',
      shopping: 'खरेदी'
      // love: "प्रेम",
      // poetry: "कविता",
      // politics: "राजकारण",
      // religious: "धार्मिक",
      // others: "इतर"
    },
    categoryNew: {
      // money91: {
      //   name: "पैसा91",
      //   paragraph:
      //     "थेट जा आणि नवीन मित्र किंवा आपली प्रतिभा दाखवा आणि टिपा मिळवा."
      // },
      questionary: {
        name: 'प्रश्नावली',
        paragraph:
          'ब्रॉडकास्टरला एक प्रश्न विचारा आणि त्याला एमॅक किंवा वॉलेटमध्ये एक टीप द्या किंवा या श्रेणीसह थेट रहा आणि आपल्या प्रेक्षकांचे प्रश्न द्या आणि पैसे कमवा.'
      },
      shopping: {
        name: 'खरेदी',
        paragraph:
          'मॉल 9 1 च्या उत्पादनांचे थेट व्हिडिओ त्यांनी विकत घेतले आहे किंवा त्यांच्या स्वत: वरच जगले आहे. आपण आपल्या खरेदी केलेल्या उत्पादनातून एखादी व्यक्ती खरेदी केली तर आपण आपल्या खरेदी केलेल्या उत्पादनांमधून अधिक कमाई करू शकता.'
      }
    },
    goLive: 'जा राहतात',
    whichtopic: 'कोणत्या विषयावर',
    talkabout: 'आपण बद्दल बोलणार?',
    rules: 'नियम व अटी',
    togolive: 'थेट जात',
    rule1:
      'आपल्याकडे जाण्यासाठी 100 किंवा 100 पेक्षा जास्त अनुयायी असणे आवश्यक आहे',
    rule2:
      'आपण आक्षेपार्ह लाइव्ह केल्यास आपण मनी 9 1 वरून कायमस्वरूपी बंदी घालू शकता',
    rule3:
      'अनुचित वर्तन किंवा लैंगिक आणि हिंसक सामग्रीमुळे आपल्या खात्यावर बंदी घातली जाऊ शकते आणि कायद्याची अंमलबजावणी करणार्या अधिकार्यांना अधिसूचित केले जाऊ शकते.',
    rule4:
      'आपण ज्या अनुभवांची खरोखर काळजी घेता त्या आपल्या सामायिक अनुभवांद्वारे आम्ही आपले नातेसंबंध मजबूत करू इच्छितो. म्हणूनच आम्ही आपण आणि इतरांची काळजी कशी घ्यावी हे समजून घेण्यासाठी सिस्टम तयार करतो आणि ती माहिती आपल्याला ती अनुभव तयार करण्यास, शोधण्यास, सामील होण्यासाठी आणि सामायिक करण्यात मदत करते.',
    rule5:
      'आम्ही आपल्या सामग्रीची मालकी हक्क सांगणार नाही परंतु आपण ते वापरण्यासाठी आम्हाला परवाना द्या.',
    rule6: 'आम्ही आशा करतो की आपला अनुभव मनी 9 1 लाइव्हवर अनुकूल असेल.',
    back: 'परत जा',
    stop: 'थांबवा',
    doyou: 'आपण काय करू इच्छिता',
    out: 'थेट बाहेर',
    yes: 'हो',
    no: 'नाही',
    follow: 'अनुसरण करा',
    following: 'अनुसरण करीत आहेत',
    ifuliketalent:
      'आपल्याला माझी प्रतिभा आवडली तर आपण मला भेटवस्तूसह प्रोत्साहित करू शकता',
    give: 'द्या',
    givereward: 'पुरस्कार द्या',
    writequestion: 'आपला प्रश्न लिहा',
    whattogiveforquestion:
      'आपल्याला आपल्या प्रश्नाचे उत्तर देण्यासाठी वॉलेट किंवा एम कॅश म्हणून देय द्यावे लागेल.',
    writequeshere: 'येथे आपला प्रश्न लिहा',
    continue: 'सुरू ठेवा',
    payforques: 'आपल्या प्रश्नासाठी पैसे द्या',
    yourques: 'आपला प्रश्न आहे',
    topay: 'पैसे भरा',
    questiontobeanswer: 'उत्तर देण्यासाठी नवीन प्रश्न',
    answeredquestion: 'उत्तर दिले',
    startchat: 'संभाषण सुरू करा',
    noquestion: 'आपल्याकडे उत्तर देण्यासाठी कोणतेही प्रश्न नाहीत.',
    netSlow: 'आपला इंटरनेट वेग कमी आहे आपला गोलिव्ह अनुभव कदाचित प्रभावी होईल.',
    startNet: 'कृपया आपले इंटरनेट कनेक्शन सुरू करा',
    upgradeApp: 'कृपया हे वैशिष्ट्य वापरण्यासाठी अॅप श्रेणीसुधारित करा.',
    appId: 'प्रथम अ‍ॅप आयडी मिळवा!',
    startCamera:
      'कृपया प्रसारण सुरू करण्यासाठी GoLive ला कॅमेरा आणि स्टोरेजमध्ये प्रवेश करण्याची अनुमती द्या.',
    broadcastKicked: 'ब्रॉडकास्टरने आपल्याला खोलीच्या बाहेर काढले.',
    plzchat: 'गप्पा सुरू करा',
    liveItem: 'जगण्यासाठी आयटम निवडा',
    changecategory: 'आपली श्रेणी बदला',
    CallingYou: 'आपल्याला कॉल करीत आहे ...',
    For: 'च्या साठी',
    MPointGiveYou: 'खासदार द्या',
    accountMayBlock:
      'अनुचित वर्तन किंवा लैंगिक आणि हिंसक सामग्रीमुळे आपल्या खात्यावर बंदी घालू शकते आणि कायद्याची अंमलबजावणी अधिका to्यांना खबर दिली जाऊ शकते.',
    writeComment: 'कृपया प्रथम टिप्पणी लिहा!',
    addedQues: 'एक नवीन प्रश्न जोडला आहे',
    CallDND: 'कॉल डीएनडी',
    CallBusy: 'व्यस्त कॉल करा',
    Openlink: 'दुवा उघडा',
    Wallet: 'पाकीट',
    CallingggYou: 'आपण कॉल करीत आहात ...',
    reportPost:
      'या पोस्टचा अहवाल दिल्याबद्दल धन्यवाद. आम्ही आपला प्रतिसाद नोंदविला आहे.',
    noWallet: 'पाकीट नाही रोकड नाही',
    Kindlyaskquestion: 'कृपया प्रश्न विचारा',
    wentwrong: 'काहीतरी चूक झाली',
    serverNotRespo: 'सर्व्हर प्रतिसाद देत नाही',
    IncreaseMPoint: 'एमपीईंट वाढवा',
    submitedques: 'आपला प्रश्न यशस्वीरित्या सबमिट केला गेला आहे.',
    Nobalance: 'शिल्लक नाही',
    liveEnded: 'थेट संपले.',
    sellYourProduct: 'आपले उत्पादन विक्री करा',
    inspireViewer: 'आपल्या दर्शकास आयटम खरेदी करण्यासाठी प्रेरित करा',
    earnOnClick: 'प्रत्येक क्लिक / विक्रीवर उत्पन्न',
    earnMPoint:
      'प्रत्येक क्लिकवर खासदार व्हा आणि प्रति आयटम विक्री 30% पर्यंत कमवा',
    clickToliveItem: 'एका क्लिकवर थेट आयटम',
    boughtthisdeal: 'लोकांनी हा करार विकत घेतला आहे',
    saleprice: 'विक्री किंमत:',
    makeLive: 'थेट करा',
    noProduct: 'आपल्याकडे कोणतेही उत्पादन नाही',
    MoreItem: 'अधिक आयटम',
    Close: 'बंद',
    Position: 'स्थिती',
    NameName: 'नाव',
    DurationTime: 'कालावधी',
    Score: 'धावसंख्या',
    WINrupees: 'विजय 10000 डॉलर',
    EventEnd: 'कार्यक्रम समाप्त',
    buyNow: 'आता खरेदी करा'
  },
  pa: {
    hearttoheart: 'ਦਿਲ-ਨਾਲ-ਦਿਲ ਦਾ ਭਾਸ਼ਣ',
    showyourtalent: 'ਆਪਣੀ ਪ੍ਰਤੀਭਾ ਨੂੰ ਦਿਖਾਓ ਅਤੇ ਐਮ-ਕੈਸ਼ ਪ੍ਰਾਪਤ ਕਰੋ',
    withPeople: 'ਲੋਕ ਤੁਹਾਡੀ ਪ੍ਰਤਿਭਾ ਦਿਖਾਉਂਦੇ ਹਨ',
    hearttoheart2: 'ਲਾਈਵ ਜਾਓ',
    withPeople2: 'ਤੁਹਾਡੇ ਮਨਪਸੰਦ ਉਤਪਾਦ ਦੇ ਨਾਲ',
    showyourtalent2: 'ਅਤੇ ਪੈਸਾ ਕਮਾਓ',
    whatsnew: 'ਅਤੇ ਐਮ-ਕੈਸ਼ ਪ੍ਰਾਪਤ ਕਰੋ',
    callingTitle: 'ਬੁਲਾਉਣਾ',
    callingDesc:
      'ਹੁਣ ਐਮਕੈਸ਼ ਦੁਆਰਾ ਆਪਣੇ ਮਨਪਸੰਦ ਪ੍ਰਸਾਰਕ ਨੂੰ ਕਾਲ ਕਰੋ. (ਐਮਕੈਸ਼ 30 ਸਕਿੰਟਾਂ ਤੋਂ ਘੱਟ ਕਾਲਾਂ ਤੇ ਉਪਲਬਧ ਨਹੀਂ ਹੋਵੇਗਾ.)',
    heartTitle: 'ਦਿਲ ਭੇਜੋ',
    heartDesc:
      'ਬ੍ਰੌਡਕਾਸਟਰ ਦੇ ਵੀਡੀਓ ਤੇ ਦਿਲਾਂ ਤੇ ਟੈਪ ਕਰੋ ਅਤੇ ਦਿਲ ਪ੍ਰਸਾਰਕ ਨੂੰ ਭੇਜੋ',
    ShoppingTitle: 'ਖਰੀਦਾਰੀ',
    shoppingDesc:
      'ਮੱਲ 91 ਤੋਂ ਖਰੀਦੇ ਸਾਮਾਨ ਤੋਂ ਲਾਈਵ ਵਸਤਾਂ ਅਤੇ ਲਾਈਵ ਰੈਫਰਲ ਪੈਸੇ. ਆਪਣੀ ਖਰੀਦ ਕੀਤੀ ਚੀਜ਼ ਨਾਲ ਲਾਈਵ ਜਾਓ ਅਤੇ ਜੇ ਕੋਈ ਤੁਹਾਨੂੰ ਖਰੀਦਦਾ ਹੈ ਤਾਂ ਤੁਹਾਨੂੰ ਇੱਕ ਬੋਨਸ ਮਿਲੇਗਾ.',
    questionTitle: 'ਪ੍ਰਸ਼ਨਾਵਲੀ',
    questionDesc:
      'ਹੁਣ ਤੁਹਾਡੇ ਦਰਸ਼ਕ ਤੁਹਾਨੂੰ ਪ੍ਰਸ਼ਨ ਪੁੱਛ ਸਕਦੇ ਹਨ, ਅਤੇ ਜਦੋਂ ਤੁਸੀਂ ਇਹਨਾਂ ਪ੍ਰਸ਼ਨਾਂ ਦੇ ਉੱਤਰ ਦਿੰਦੇ ਹੋ ਤਾਂ ਤੁਸੀਂ ਮੈੌਕ ਪ੍ਰਾਪਤ ਕਰੋਗੇ ਤਾਂ ਜੋ ਤੁਸੀਂ ਲਾਈਵ ਜਾਦੇ ਸਮੇਂ ਪ੍ਰਸ਼ਨਾਵਲੀ ਦੀ ਸ਼੍ਰੇਣੀ ਦੀ ਚੋਣ ਕਰ ਸਕੋ. ਇਸਤੋਂ ਬਾਅਦ ਤੁਹਾਡੇ ਦਰਸ਼ਕਾਂ ਨੂੰ ਤੁਹਾਨੂੰ ਸਵਾਲ ਪੁੱਛਣ ਦਾ ਮੌਕਾ ਮਿਲੇਗਾ ਅਤੇ ਤੁਸੀਂ ਵੀ ਇਸ ਲਈ ਵੀ ਆਪਣੇ ਮੁੱਕੇ ਨੂੰ ਮੁਫਤ ਕਰ ਸਕਦੇ ਹੋ.',

    Questionare: 'ਪ੍ਰਸ਼ਨਾਵਲੀ',
    questionasked: 'ਪੁਰਾਣੇ ਸਵਾਲ ਤੁਸੀਂ ਪੁੱਛੇ',
    category: {
      //money91: "ਪੈਸਾ91",
      questionary: 'ਪ੍ਰਸ਼ਨਾਵਲੀ',
      shopping: 'ਖਰੀਦਦਾਰੀ'
      // love: "ਪਿਆਰ",
      // poetry: "ਕਵਿਤਾ",
      //politics: "ਰਾਜਨੀਤੀ",
      // religious: "ਧਾਰਮਿਕ",
      // others: "ਹੋਰ"
    },
    categoryNew: {
      // money91: {
      //   name: "ਪੈਸਾ91",
      //   paragraph:
      //     "ਲਾਈਵ ਜਾਓ ਅਤੇ ਨਵੇਂ ਦੋਸਤ ਜਾਂ ਆਪਣੀ ਪ੍ਰਤਿਭਾ ਦਿਖਾਓ ਅਤੇ ਸੁਝਾਅ ਕਮਾਓ."
      // },
      questionary: {
        name: 'ਪ੍ਰਸ਼ਨਾਵਲੀ',
        paragraph:
          'ਬ੍ਰੌਡਕਾਸਟਰ ਨੂੰ ਇੱਕ ਸਵਾਲ ਪੁੱਛੋ ਅਤੇ ਉਸਨੂੰ ਏਐਮਐਕਸ ਜਾਂ ਵਾਲਟ ਵਿੱਚ ਕੋਈ ਟਿਪ ਦਿਓ ਜਾਂ ਇਸ ਸ਼੍ਰੇਣੀ ਨਾਲ ਖੁਦ ਜੀਓ ਅਤੇ ਆਪਣੇ ਦਰਸ਼ਕਾਂ ਦੇ ਸਵਾਲਾਂ ਦੇ ਜਵਾਬ ਦਿਓ ਅਤੇ ਪੈਸੇ ਕਮਾਓ.'
      },
      shopping: {
        name: 'ਖਰੀਦਦਾਰੀ',
        paragraph:
          'ਮਾਲ 91 ਦੇ ਉਤਪਾਦਾਂ ਦੇ ਲਾਈਵ ਵੀਡੀਓ ਨੂੰ ਉਨ੍ਹਾਂ ਲੋਕਾਂ ਤੋਂ ਖਰੀਦੋ ਜਿਹਨਾਂ ਨੇ ਉਨ੍ਹਾਂ ਨੂੰ ਖਰੀਦਿਆ ਹੈ ਜਾਂ ਆਪਣੇ ਆਪ ਹੀ ਜੀਊਂਦੇ ਹੋ. ਤੁਸੀਂ ਆਪਣੇ ਖਰੀਦੇ ਉਤਪਾਦਾਂ ਤੋਂ ਹੋਰ ਕਮਾਉਂਦੇ ਹੋ, ਜੇਕਰ ਕੋਈ ਵਿਅਕਤੀ ਤੁਹਾਡੇ ਲਾਇਵ ਤੋਂ ਉਹ ਉਤਪਾਦ ਖਰੀਦਦਾ ਹੈ.'
      }
    },
    goLive: 'ਜਾਣਾ ਲਾਈਵ',
    whichtopic: 'ਕਿਸ ਵਿਸ਼ੇ ਤੇ',
    talkabout: 'ਕੀ ਤੁਸੀਂ ਇਸ ਬਾਰੇ ਗੱਲ ਕਰੋਗੇ?',
    rules: 'ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ',
    togolive: 'ਜੀਉਣ ਦਾ',
    rule1:
      'ਤੁਹਾਡੇ ਕੋਲ 100 ਤੋਂ ਵੱਧ ਜਾਂ 100 ਤੋਂ ਵੱਧ ਸ਼ਰਧਾਲੂ ਲਾਈਵ ਹੋਣ ਲਈ ਹੋਣੇ ਚਾਹੀਦੇ ਹਨ',
    rule2:
      'ਜੇਕਰ ਤੁਸੀਂ ਇਤਰਾਜ਼ਯੋਗ ਲਾਈਵ ਕਰ ਰਹੇ ਹੋ ਤਾਂ ਤੁਸੀਂ ਮਨੀ 9 1 ਤੋਂ ਸਥਾਈ ਤੌਰ ਤੇ ਪਾਬੰਦੀ ਲਗਾ ਸਕਦੇ ਹੋ',
    rule3:
      'ਅਣਉਚਿਤ ਵਰਤਾਓ ਜਾਂ ਜਿਨਸੀ ਅਤੇ ਹਿੰਸਕ ਸਮੱਗਰੀ ਦੇ ਨਤੀਜੇ ਵਜੋਂ ਤੁਹਾਡੇ ਖਾਤੇ ਤੇ ਪਾਬੰਦੀ ਲਗਾਦਿੱਤੀ ਜਾ ਸਕਦੀ ਹੈ ਅਤੇ ਕਾਨੂੰਨ ਲਾਗੂ ਕਰਨ ਵਾਲੇ ਅਧਿਕਾਰੀਆਂ ਨੂੰ ਸੂਚਿਤ ਕੀਤਾ ਜਾ ਸਕਦਾ ਹੈ.',
    rule4:
      'ਅਸੀਂ ਤੁਹਾਡੇ ਸ਼ੇਅਰ ਕਰਨ ਵਾਲੇ ਅਨੁਭਵਾਂ ਰਾਹੀਂ ਆਪਣੇ ਸਬੰਧਾਂ ਨੂੰ ਮਜਬੂਤ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹਾਂ, ਜਿਸ ਬਾਰੇ ਤੁਸੀਂ ਅਸਲ ਵਿੱਚ ਪਰਵਾਹ ਕਰਦੇ ਹੋ. ਇਹੀ ਕਾਰਨ ਹੈ ਕਿ ਅਸੀਂ ਸਿਸਟਮ ਬਣਾਉਂਦੇ ਹਾਂ ਜੋ ਤੁਹਾਨੂੰ ਇਹ ਸਮਝਣ ਦੀ ਕੋਸ਼ਿਸ਼ ਕਰਦੇ ਹਨ ਕਿ ਤੁਸੀਂ ਅਤੇ ਹੋਰ ਕੀ ਕਰਦੇ ਹਨ, ਅਤੇ ਉਹ ਜਾਣਕਾਰੀ ਤੁਹਾਨੂੰ ਉਨ੍ਹਾਂ ਅਨੁਭਵਾਂ ਨੂੰ ਬਣਾਉਣ, ਖੋਜਣ ਅਤੇ ਉਹਨਾਂ ਵਿੱਚ ਸਾਂਝ ਪਾਉਣ ਵਿੱਚ ਸਹਾਇਤਾ ਕਰਦੀ ਹੈ.',
    rule5:
      'ਅਸੀਂ ਤੁਹਾਡੀ ਸਮਗਰੀ ਦੀ ਮਾਲਕੀ ਦਾ ਦਾਅਵਾ ਨਹੀਂ ਕਰਦੇ, ਪਰ ਤੁਸੀਂ ਸਾਨੂੰ ਇਸ ਦੀ ਵਰਤੋਂ ਕਰਨ ਦਾ ਲਾਇਸੰਸ ਦਿੰਦੇ ਹੋ.',
    rule6: 'ਅਸੀਂ ਉਮੀਦ ਕਰਦੇ ਹਾਂ ਕਿ ਤੁਹਾਡਾ ਅਨੁਭਵ Money91 Live ਤੇ ਅਨੁਕੂਲ ਹੋਵੇਗਾ.',
    back: 'ਵਾਪਸ ਜਾਓ',
    stop: 'ਰੂਕੋ',
    doyou: 'ਕੀ ਤੁਸੀਂ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ',
    out: 'ਲਾਈਵ ਤੋਂ ਬਾਹਰ',
    yes: 'ਹਾਂ',
    no: 'ਨਹੀਂ',
    follow: 'ਦੀ ਪਾਲਣਾ ਕਰੋ',
    following: 'ਹੇਠ ਲਿਖੇ ਹਨ',
    ifuliketalent:
      'ਜੇ ਤੁਸੀਂ ਮੇਰੀ ਪ੍ਰਤਿਭਾ ਚਾਹੁੰਦੇ ਹੋ ਤਾਂ ਤੁਸੀਂ ਮੈਨੂੰ ਤੋਹਫ਼ਾ ਦੇ ਕੇ ਉਤਸ਼ਾਹਿਤ ਕਰ ਸਕਦੇ ਹੋ',
    give: 'ਇਸਨੂੰ ਦਿਓ',
    givereward: 'ਇਨਾਮ ਦਿਓ',
    writequestion: 'ਆਪਣਾ ਸਵਾਲ ਲਿਖੋ',
    whattogiveforquestion:
      'உங்கள் கேள்விக்குப் பதில் ஒரு வாலெட் அல்லது எம் ரொக்கமாக செலுத்த வேண்டும்.',
    writequeshere: 'ਆਪਣਾ ਸਵਾਲ ਇੱਥੇ ਲਿਖੋ',
    continue: 'ਜਾਰੀ ਰੱਖੋ',
    payforques: 'ਆਪਣੇ ਪ੍ਰਸ਼ਨ ਲਈ ਭੁਗਤਾਨ ਕਰੋ',
    yourques: 'ਤੁਹਾਡਾ ਸਵਾਲ ਹੈ',
    topay: 'ਭੁਗਤਾਨ ਕਰੋ',
    questiontobeanswer: 'ਜਵਾਬ ਦੇਣ ਲਈ ਨਵਾਂ ਸਵਾਲ',
    answeredquestion: 'ਉੱਤਰ ਦਿੱਤਾ',
    startchat: 'ਗੱਲਬਾਤ ਸ਼ੁਰੂ ਕਰੋ',
    noquestion: 'ਜਵਾਬ ਦੇਣ ਲਈ ਤੁਹਾਡੇ ਕੋਲ ਕੋਈ ਸਵਾਲ ਨਹੀਂ ਹੈ.',
    netSlow:
      'ਤੁਹਾਡੀ ਇੰਟਰਨੈਟ ਦੀ ਗਤੀ ਹੌਲੀ ਹੈ ਤੁਹਾਡਾ ਪ੍ਰਭਾਵਸ਼ਾਲੀ ਤਜ਼ਰਬਾ ਪ੍ਰਭਾਵਤ ਹੋ ਸਕਦਾ ਹੈ.',
    startNet: 'ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਇੰਟਰਨੈਟ ਕਨੈਕਸ਼ਨ ਸ਼ੁਰੂ ਕਰੋ',
    upgradeApp: 'ਕਿਰਪਾ ਕਰਕੇ ਇਸ ਵਿਸ਼ੇਸ਼ਤਾ ਦੀ ਵਰਤੋਂ ਕਰਨ ਲਈ ਐਪ ਨੂੰ ਅਪਗ੍ਰੇਡ ਕਰੋ.',
    appId: 'ਪਹਿਲਾਂ ਐਪ ਆਈਡੀ ਲਓ!',
    startCamera:
      'ਕਿਰਪਾ ਕਰਕੇ ਪ੍ਰਸਾਰਨ ਅਰੰਭ ਕਰਨ ਲਈ GoLive ਨੂੰ ਕੈਮਰਾ ਅਤੇ ਸਟੋਰੇਜ ਤੱਕ ਪਹੁੰਚ ਦੀ ਆਗਿਆ ਦਿਓ.',
    broadcastKicked: 'ਪ੍ਰਸਾਰਕ ਨੇ ਤੁਹਾਨੂੰ ਕਮਰੇ ਵਿੱਚੋਂ ਬਾਹਰ ਕੱ ofਿਆ.',
    plzchat: 'ਗੱਲਬਾਤ ਸ਼ੁਰੂ ਕਰੋ',
    liveItem: 'ਰਹਿਣ ਲਈ ਇਕਾਈ ਦੀ ਚੋਣ ਕਰੋ',
    changecategory: 'ਆਪਣੀ ਸ਼੍ਰੇਣੀ ਬਦਲੋ',
    CallingYou: 'ਤੁਹਾਨੂੰ ਕਾਲ ਕਰ ਰਿਹਾ ਹਾਂ ...',
    For: 'ਲਈ',
    MPointGiveYou: 'ਐਮਪੀਓਂਟ ਯੂ',
    accountMayBlock:
      'ਅਣਉਚਿਤ ਵਿਵਹਾਰ ਜਾਂ ਜਿਨਸੀ ਅਤੇ ਹਿੰਸਕ ਸਮਗਰੀ ਦੇ ਨਤੀਜੇ ਵਜੋਂ ਤੁਹਾਡੇ ਖਾਤੇ ਤੇ ਪਾਬੰਦੀ ਲਗਾਈ ਜਾ ਸਕਦੀ ਹੈ ਅਤੇ ਕਾਨੂੰਨ ਲਾਗੂ ਕਰਨ ਵਾਲੇ ਅਧਿਕਾਰੀਆਂ ਨੂੰ ਰਿਪੋਰਟ ਕੀਤੀ ਜਾ ਸਕਦੀ ਹੈ.',
    writeComment: 'ਕਿਰਪਾ ਕਰਕੇ ਪਹਿਲਾਂ ਟਿੱਪਣੀ ਲਿਖੋ!',
    addedQues: 'ਇੱਕ ਨਵਾਂ ਪ੍ਰਸ਼ਨ ਜੋੜਿਆ ਗਿਆ ਹੈ',
    CallDND: 'ਕਾਲ ਕਰੋ ਡੀ.ਐਨ.ਡੀ.',
    CallBusy: 'ਬਿਜ਼ੀ ਨੂੰ ਕਾਲ ਕਰੋ',
    Openlink: 'ਲਿੰਕ ਖੋਲ੍ਹੋ',
    Wallet: 'ਬਟੂਆ',
    CallingggYou: 'ਤੁਸੀਂ ਕਾਲ ਕਰ ਰਹੇ ਹੋ ...',
    reportPost:
      'ਇਸ ਪੋਸਟ ਨੂੰ ਰਿਪੋਰਟ ਕਰਨ ਲਈ ਧੰਨਵਾਦ. ਅਸੀਂ ਤੁਹਾਡਾ ਜਵਾਬ ਦਰਜ ਕਰ ਲਿਆ ਹੈ.',
    noWallet: 'ਕੋਈ ਬਟੂਆ ਨਹੀਂ ਨਕਦ',
    Kindlyaskquestion: 'ਕਿਰਪਾ ਕਰਕੇ ਪ੍ਰਸ਼ਨ ਪੁੱਛੋ.',
    wentwrong: 'ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ',
    serverNotRespo: 'ਸਰਵਰ ਜਵਾਬ ਨਹੀਂ ਦੇ ਰਿਹਾ',
    IncreaseMPoint: 'ਐਮਪੋਇੰਟ ਵਧਾਓ',
    submitedques: 'ਤੁਹਾਡਾ ਪ੍ਰਸ਼ਨ ਸਫਲਤਾਪੂਰਵਕ ਦਰਜ ਕੀਤਾ ਗਿਆ ਹੈ.',
    Nobalance: 'ਕੋਈ ਬਕਾਇਆ ਨਹੀਂ',
    liveEnded: 'ਲਾਈਵ ਖਤਮ ਹੋ ਗਿਆ ਹੈ.',
    sellYourProduct: 'ਆਪਣੇ ਉਤਪਾਦ ਨੂੰ ਵੇਚੋ',
    inspireViewer: 'ਆਪਣੇ ਦਰਸ਼ਕ ਨੂੰ ਚੀਜ਼ਾਂ ਖਰੀਦਣ ਲਈ ਪ੍ਰੇਰਿਤ ਕਰੋ',
    earnOnClick: "ਹਰ ਕਲਿੱਕ / ਵਿਕਰੀ 'ਤੇ ਕਮਾਏ ਗਏ",
    earnMPoint:
      "ਹਰ ਕਲਿਕ 'ਤੇ ਐਮਪੀਓਇੰਟ ਪ੍ਰਾਪਤ ਕਰੋ, ਅਤੇ ਪ੍ਰਤੀ ਆਈਟਮ ਵਿਕਰੀ 30% ਤੱਕ ਕਮਾਓ",
    clickToliveItem: 'ਇੱਕ ਕਲਿੱਕ ਨਾਲ ਲਾਈਵ ਆਈਟਮ',
    boughtthisdeal: 'ਲੋਕਾਂ ਨੇ ਇਹ ਸੌਦਾ ਖ੍ਰੀਦਿਆ ਹੈ',
    saleprice: 'ਵਿਕਰੀ ਮੁੱਲ:',
    makeLive: 'ਲਾਈਵ ਬਣਾਓ',
    noProduct: 'ਤੁਹਾਡੇ ਕੋਲ ਕੋਈ ਉਤਪਾਦ ਨਹੀਂ ਹੈ',
    MoreItem: 'ਹੋਰ ਆਈਟਮ',
    Close: 'ਬੰਦ ਕਰੋ',
    Position: 'ਸਥਿਤੀ',
    NameName: 'ਨਾਮ',
    DurationTime: 'ਅੰਤਰਾਲ ਸਮਾਂ',
    Score: 'ਸਕੋਰ',
    WINrupees: 'ਜਿੱਤ ₹ 10000',
    EventEnd: 'ਇਵੈਂਟ ਅੰਤ',
    buyNow: 'ਹੁਣੇ ਖਰੀਦੋ'
  },
  ta: {
    hearttoheart: 'இதயத்திற்கு இதயம்',
    showyourtalent: 'மக்களுடன் உங்கள் திறமையைக் காட்டுங்கள்',
    withPeople: 'எம்-பணத்தைப் பெறுங்கள்',
    hearttoheart2: 'நேரலைக்குச் செல்லுங்கள்',
    withPeople2: 'உங்களுக்கு பிடித்த தயாரிப்புடன்',
    showyourtalent2: 'மற்றும் பணம் சம்பாதிக்க',
    whatsnew: 'புதியது என்ன',
    callingTitle: 'அழைப்புக்',
    callingDesc:
      'இப்போது உங்களுக்கு பிடித்த ஒளிபரப்பாளரை MPoint மூலம் அழைக்கவும். (30 வினாடிகளுக்கு குறைவான அழைப்புகளில் MPoint கிடைக்காது.)',
    heartTitle: 'இதயத்தை அனுப்புங்கள்',
    heartDesc:
      'ஹார்ட்ஸ் லைவ் ஆன் பிராட்காஸ்டரின் வீடியோவில் தட்டவும் மற்றும் ஹார்ட்ஸ் பிராட்காஸ்டருக்கு அனுப்பவும்',
    ShoppingTitle: 'கொள்முதல்',
    shoppingDesc:
      'மால் 91 இலிருந்து வாங்கிய பொருட்களிலிருந்து நேரடி பொருட்கள் மற்றும் நேரடி பரிந்துரைகள் பணம். நீங்கள் வாங்கிய உருப்படியுடன் நேரலைக்குச் செல்லுங்கள், யாராவது உங்களை நேரலையில் வாங்கினால் உங்களுக்கு போனஸ் கிடைக்கும்.',
    questionTitle: 'கேள்வித்தாளை',
    questionDesc:
      'இப்போது உங்கள் பார்வையாளர்கள் உங்களிடம் கேள்விகளைக் கேட்கலாம், இந்தக் கேள்விகளுக்கு நீங்கள் பதிலளிக்கும்போது MPoint ஐப் பெற வேண்டும், இதனால் நேரலைக்குச் செல்லும்போது கேள்வித்தாளின் வகையைத் தேர்ந்தெடுக்கலாம். அதன்பிறகு உங்கள் பார்வையாளர்கள் உங்களிடம் கேள்விகளைக் கேட்க ஒரு வாய்ப்பு கிடைக்கும், அதற்காக உங்கள் MPoint ஐயும் விடுவிக்கலாம்.',
    Questionare: 'கேள்வித்தாளை',
    questionasked: 'ீங்கள் கேட்ட பழைய கேள்விகள்',
    category: {
      // money91: "பணம்91",
      questionary: 'கேள்வித்தாளை',
      shopping: 'கடையில் பொருட்கள் வாங்குதல்'
      // love: "லவ்",
      // poetry: "கவிதைகள்",
      // politics: "அரசியல்",
      // religious: "மத",
      // others: "மற்றவர்கள்"
    },
    categoryNew: {
      // money91: {
      //   name: "பணம்91",
      //   paragraph:
      //     "நேரலைக்குச் சென்று புதிய நண்பர்களையோ அல்லது உங்கள் திறமைகளையோ காட்டி உதவிக்குறிப்புகளைப் பெறுங்கள்."
      // },
      questionary: {
        name: 'கேள்வித்தாளை',
        paragraph:
          'ஒளிபரப்பாளரிடம் ஒரு கேள்வியைக் கேளுங்கள், அவருக்கு ஈமாக்ஸ் அல்லது பணப்பையில் ஒரு உதவிக்குறிப்பைக் கொடுங்கள் அல்லது இந்த வகையுடன் நீங்களே நேரலையில் சென்று உங்கள் பார்வையாளர்களின் கேள்விகளுக்கு பதிலளித்து பணம் சம்பாதிக்கவும்.'
      },
      shopping: {
        name: 'கடையில் பொருட்கள் வாங்குதல்',
        paragraph:
          'மால் 91 இன் தயாரிப்புகளை வாங்கியவர்களிடமிருந்து அல்லது சொந்தமாக நேரலைக்குச் சென்றவர்களிடமிருந்து நேரடி வீடியோவைப் பாருங்கள்.உங்கள் நேரலையில் இருந்து யாராவது அந்த தயாரிப்பை வாங்கினால், நீங்கள் வாங்கிய பொருட்களிலிருந்து அதிகம் சம்பாதிக்கிறீர்கள்.'
      }
      // livetv91: {
      //   name: "நேரடி தொலைக்காட்சி 91",
      //   paragraph:
      //     "உங்களுக்கு பிடித்த பாடல்களின் வீடியோக்களைக் காண்க. பணம் 91 இல் டிவியை அனுபவிக்கவும்"
      // }
    },
    goLive: 'போய் நேரடி',
    whichtopic: 'எந்த தலைப்பில்',
    talkabout: 'நீங்கள் பேசுவீர்களா?',
    rules: 'விதிமுறைகள் மற்றும் நிபந்தனைகள்',
    togolive: 'வாழ போகிறது',
    rule1:
      '100 க்கும் அதிகமானோர் அல்லது 100 க்கும் மேற்பட்ட பின்தொடர்பவர்கள் வாழ வேண்டும்',
    rule2:
      'நீங்கள் ஆட்சேபிக்கக்கூடிய நேரடி செய்தால், Money91 இலிருந்து நிரந்தரமாக தடைசெய்யலாம்',
    rule3:
      'பொருத்தமற்ற நடத்தை அல்லது பாலியல் மற்றும் வன்முறை உள்ளடக்கம் உங்கள் கணக்கில் தடை செய்யப்பட்டு, சட்ட அமலாக்க அதிகாரிகள் அறிவிக்கப்படலாம்.',
    rule4:
      'நீங்கள் பகிர்ந்து கொள்ளும் அனுபவங்களின் மூலம் உங்கள் உறவுகளை பலப்படுத்த விரும்புகிறோம். அதனால்தான், நீங்களும் மற்றவர்களும் கவலைப்படுவதை புரிந்துகொள்ள முயற்சிக்கும் முறைகள் உருவாக்கப்பட்டு, அந்த அனுபவங்களை நீங்கள் உருவாக்கவும், கண்டுபிடிக்கவும், சேரவும், பகிர்ந்து கொள்ளவும் உதவுகின்றன.',
    rule5:
      'உங்கள் உள்ளடக்கத்தின் உரிமையை நாங்கள் உரிமை கோரவில்லை, ஆனால் அதைப் பயன்படுத்த எங்களுக்கு உரிமம் தருகிறது.',
    rule6:
      'Money91 லைவ் மீது உங்கள் அனுபவம் சாதகமானது என்று நாங்கள் நம்புகிறோம்.',
    back: 'திரும்பிப் போ',
    stop: 'நிறுத்து',
    doyou: 'என்ன செய்வது',
    out: 'நேரடி அவுட்',
    yes: 'ஆம்',
    no: 'இல்லை',
    follow: 'பின்பற்றவும்',
    following: 'தொடர்ந்து',
    ifuliketalent:
      'என் திறமை உங்களுக்கு பிடித்திருந்தால், ஒரு பரிசை என்னால் ஊக்குவிக்க முடியும்',
    give: 'கொடுங்கள்',
    givereward: 'வெகுமதி கொடுங்கள்',
    writequestion: 'உங்கள் கேள்வியை எழுதுங்கள்',
    whattogiveforquestion:
      'உங்கள் கேள்விக்குப் பதில் ஒரு வாலெட் அல்லது எம் ரொக்கமாக செலுத்த வேண்டும்.',
    writequeshere: 'இங்கே உங்கள் கேள்வியை எழுதுங்கள்',
    continue: 'தொடர்ந்து',
    payforques: 'உங்கள் கேள்விக்கு பணம் கொடுங்கள்',
    yourques: 'உங்கள் கேள்வி',
    topay: 'பணம் செலுத்துங்கள்',
    questiontobeanswer: 'பதில் புதிய கேள்வி',
    answeredquestion: 'பதில்',
    startchat: 'உரையாடலைத் தொடங்கவும்',
    noquestion: 'உங்களுக்கு பதிலளிக்க கேள்விகள் எதுவும் இல்லை.',
    netSlow:
      'உங்கள் இணைய வேகம் மெதுவாக உள்ளது, உங்கள் கோலி அனுபவம் அனுபவமாக இருக்கலாம்.',
    startNet: 'உங்கள் இணைய இணைப்பைத் தொடங்கவும்',
    upgradeApp: 'இந்த அம்சத்தைப் பயன்படுத்த பயன்பாட்டை மேம்படுத்தவும்.',
    appId: 'முதலில் பயன்பாட்டு ஐடியைப் பெறுங்கள்!',
    startCamera:
      'ஒளிபரப்பைத் தொடங்க கேமரா மற்றும் சேமிப்பிடத்தை அணுக கோலைவை அனுமதிக்கவும்.',
    broadcastKicked: 'ஒளிபரப்பாளர் உங்களை அறையிலிருந்து வெளியேற்றினார்.',
    plzchat: 'அரட்டை தொடங்கவும்',
    liveItem: 'வாழ உருப்படியைத் தேர்ந்தெடுக்கவும்',
    changecategory: 'உங்கள் வகையை மாற்றவும்',
    CallingYou: 'உங்களை அழைக்கிறது ...',
    For: 'க்கு',
    MPointGiveYou: 'MPoint உங்களுக்கு கொடுங்கள்',
    accountMayBlock:
      'பொருத்தமற்ற நடத்தை அல்லது பாலியல் மற்றும் வன்முறை உள்ளடக்கம் உங்கள் கணக்கு தடைசெய்யப்பட்டு சட்ட அமலாக்க அதிகாரிகளுக்கு புகாரளிக்கப்படலாம்.',
    writeComment: 'முதலில் கருத்து எழுதுங்கள்!',
    addedQues: 'ஒரு புதிய கேள்வி சேர்க்கப்பட்டுள்ளது',
    CallDND: 'ஐ அழைக்கவும்',
    CallBusy: 'பிஸி என்று அழைக்கவும்',
    Openlink: 'இணைப்பைத் திறக்கவும்',
    Wallet: 'Wallet',
    CallingggYou: 'நீங்கள் அழைக்கிறீர்கள் ...',
    reportPost:
      'இந்த இடுகையைப் புகாரளித்ததற்கு நன்றி. உங்கள் பதிலை பதிவு செய்துள்ளோம்.',
    noWallet: 'பணப்பையில் பணம் இல்லை',
    Kindlyaskquestion: 'தயவுசெய்து கேள்வி கேளுங்கள்.',
    wentwrong: 'ஏதோ தவறு நடைபெற்றிருக்கிறது',
    serverNotRespo: 'சேவையகம் பதிலளிக்கவில்லை',
    IncreaseMPoint: 'MPoint ஐ அதிகரிக்கவும்',
    submitedques: 'உங்கள் கேள்வி வெற்றிகரமாக சமர்ப்பிக்கப்பட்டுள்ளது.',
    Nobalance: 'இருப்பு இல்லை',
    liveEnded: 'லைவ் முடிந்தது.',
    sellYourProduct: 'உங்கள் தயாரிப்பை விற்கவும்',
    inspireViewer: 'பொருட்களை வாங்க உங்கள் பார்வையாளரை ஊக்குவிக்கவும்',
    earnOnClick: 'ஒவ்வொரு கிளிக் / விற்பனையிலும் சம்பாதித்தார்',
    earnMPoint:
      'ஒவ்வொரு கிளிக்கிலும் MPoint ஐப் பெற்று, ஒரு பொருள் விற்பனைக்கு 30% வரை சம்பாதிக்கவும்',
    clickToliveItem: 'ஒரே கிளிக்கில் நேரடி உருப்படி',
    boughtthisdeal: 'இந்த ஒப்பந்தத்தை மக்கள் வாங்கியுள்ளனர்',
    saleprice: 'விற்பனை விலை:',
    makeLive: 'லைவ் செய்யுங்கள்',
    noProduct: 'உங்களிடம் எந்த தயாரிப்பு இல்லை',
    MoreItem: 'மேலும் பொருள்',
    Close: 'நெருக்கமான',
    Position: 'நிலை',
    NameName: 'பெயர்',
    DurationTime: 'காலம் நேரம்',
    Score: 'ஸ்கோர்',
    WINrupees: 'வின் ₹ 10000',
    EventEnd: 'நிகழ்வு முடிவு',
    buyNow: 'இப்போது வாங்க'
  },
  te: {
    hearttoheart: 'హృదయపూర్వక చర్చ',
    showyourtalent: 'వ్యక్తులతో మీ ప్రతిభను చూపండి',
    withPeople: 'మరియు M- నగదు పొందండి',
    hearttoheart2: 'ప్రత్యక్ష ప్రసారం చేయండి',
    withPeople2: 'మీకు ఇష్టమైన ఉత్పత్తితో',
    showyourtalent2: 'మరియు డబ్బు సంపాదించండి',
    whatsnew: 'క్రొత్తది ఏమిటి',
    callingTitle: 'కాలింగ్',
    callingDesc:
      'ఇప్పుడు మీ ఇష్టమైన బ్రాడ్‌కాస్టర్‌ను MPoint ద్వారా కాల్ చేయండి. (MPoint 30 సెకన్ల లోపు కాల్‌లలో అందుబాటులో ఉండదు.)',
    heartTitle: 'హృదయాన్ని పంపండి',
    heartDesc:
      'బ్రాడ్కాస్టర్ వీడియోలో హార్ట్స్ లైవ్ నొక్కండి మరియు హార్ట్స్ బ్రాడ్కాస్టర్కు పంపండి',
    ShoppingTitle: 'కొనుగోలు',
    shoppingDesc:
      'మాల్ 91 నుండి కొనుగోలు చేసిన వస్తువుల నుండి లైవ్ గూడ్స్ మరియు లైవ్ రిఫరల్స్ డబ్బు. మీరు కొనుగోలు చేసిన వస్తువుతో ప్రత్యక్ష ప్రసారం చేయండి మరియు ఎవరైనా మిమ్మల్ని ప్రత్యక్షంగా కొనుగోలు చేస్తే మీకు బోనస్ లభిస్తుంది.',
    questionTitle: 'ప్రశ్నాపత్రం',
    questionDesc:
      'ఇప్పుడు మీ ప్రేక్షకులు మిమ్మల్ని ప్రశ్నలు అడగవచ్చు మరియు మీరు ఈ ప్రశ్నలకు సమాధానం ఇచ్చినప్పుడు మీరు MPoint ను పొందవలసి ఉంటుంది, తద్వారా మీరు ప్రత్యక్ష ప్రసారం చేసేటప్పుడు ప్రశ్నపత్రం యొక్క వర్గాన్ని ఎంచుకోవచ్చు. ఆ తరువాత మీ ప్రేక్షకులు మీకు ప్రశ్నలు అడిగే అవకాశం లభిస్తుంది మరియు మీరు మీ MPoint ని కూడా విడిపించవచ్చు.',
    Questionare: 'ప్రశ్నాపత్రం',
    questionasked: 'మీరు అడిగిన పాత ప్రశ్నలు',
    category: {
      // money91: "మనీ91",
      questionary: 'ప్రశ్నాపత్రం',
      shopping: 'షాపింగ్'
      // love: "లవ్",
      // poetry: "కవిత్వం"
      // politics: "రాజకీయాలు",
      // religious: "మత",
      // others: "ఇతరులు"
    },
    categoryNew: {
      // money91: {
      //   name: "మనీ91",
      //   paragraph:
      //     "ప్రత్యక్ష ప్రసారం చేసి, క్రొత్త స్నేహితులను లేదా మీ ప్రతిభను చూపించి చిట్కాలను సంపాదించండి."
      // },
      questionary: {
        name: 'ప్రశ్నాపత్రం',
        paragraph:
          'బ్రాడ్‌కాస్టర్‌ను ఒక ప్రశ్న అడగండి మరియు అతనికి ఇమాక్స్ లేదా వాలెట్‌లో చిట్కా ఇవ్వండి లేదా ఈ వర్గంతో మీరే ప్రత్యక్షంగా వెళ్లి మీ ప్రేక్షకుల ప్రశ్నలకు సమాధానం ఇవ్వండి మరియు డబ్బు సంపాదించండి.'
      },
      shopping: {
        name: 'షాపింగ్',
        paragraph:
          'మాల్ 91 యొక్క ఉత్పత్తులను కొనుగోలు చేసిన వారి నుండి ప్రత్యక్షంగా చూడండి లేదా వారి స్వంతంగా ప్రత్యక్ష ప్రసారం చేయండి.మీరు మీ ఉత్పత్తి నుండి ఎవరైనా ఆ ఉత్పత్తిని కొనుగోలు చేస్తే మీరు కొనుగోలు చేసిన ఉత్పత్తుల నుండి ఎక్కువ సంపాదిస్తారు.'
      }
    },
    goLive: 'వెళ్ళండి ప్రత్యక్ష',
    whichtopic: 'ఏ అంశంపై',
    talkabout: 'మీరు మాట్లాడతారా?',
    rules: 'నిబంధనలు మరియు షరతులు',
    togolive: 'ప్రత్యక్ష ప్రసారం',
    rule1: 'మీకు 100 మంది కంటే ఎక్కువ మంది అనుచరులు ప్రత్యక్ష ప్రసారం కావాలి',
    rule2:
      'మీరు ఒక అభ్యంతరకరమైన లైవ్ చేస్తే Money91 నుండి శాశ్వతంగా నిషేధించబడవచ్చు',
    rule3:
      'అనుచితమైన ప్రవర్తన లేదా లైంగిక మరియు హింసాత్మక కంటెంట్ మీ ఖాతాకు నిషేధించడం మరియు చట్ట అమలు అధికారులకు తెలియజేయబడవచ్చు.',
    rule4:
      'మీరు పంచుకున్న అనుభవాల ద్వారా మీ సంబంధాలను బలోపేతం చేసుకోవాలని మేము కోరుకుంటున్నాము, మీరు నిజంగా జాగ్రత్త పడుతున్నారు. అందువల్ల మీరు మరియు ఇతరులు శ్రద్ధ వహించేవాటిని అర్థం చేసుకోవడానికి మేము ప్రయత్నిస్తున్న వ్యవస్థలను నిర్మించాము మరియు ఆ అనుభవాలు మిమ్మల్ని సృష్టించగలవు, కనుగొనండి, చేరడానికి మరియు ఆ అనుభవాలను పంచుకోండి.',
    rule5:
      'మీ కంటెంట్ యొక్క యాజమాన్యాన్ని మేము క్లెయిమ్ చేయలేము, కాని దాన్ని ఉపయోగించడానికి మాకు లైసెన్స్ ఇవ్వండి.',
    rule6: 'మీ అనుభవం Money91 Live లో అనుకూలమైనదని మేము ఆశిస్తున్నాము.',
    back: 'వెనక్కి వెళ్ళు',
    stop: 'ఆపు',
    doyou: 'మీరు చెప్పేది కావాలి',
    out: 'ప్రత్యక్ష ప్రసారం',
    yes: 'అవును',
    no: 'ఏ',
    follow: 'అనుసరించండి',
    following: 'అనుసరిస్తున్నారు',
    ifuliketalent: 'మీరు నా ప్రతిభను ఇష్టపడితే బహుమతితో నన్ను ప్రోత్సహిస్తారు',
    give: 'ఇవ్వండి',
    givereward: 'బహుమతి ఇవ్వండి',
    writequestion: 'మీ ప్రశ్న వ్రాయండి',
    whattogiveforquestion:
      'మీ ప్రశ్నకు మీరు ఒక వాలెట్ లేదా ఎం క్యాష్గా చెల్లించాలి.',
    writequeshere: 'ఇక్కడ మీ ప్రశ్న వ్రాయండి',
    continue: 'కొనసాగించు',
    payforques: 'మీ ప్రశ్నకు చెల్లించండి',
    yourques: 'మీ ప్రశ్న',
    topay: 'చెల్లింపు చేయండి',
    questiontobeanswer: 'సమాధానం కొత్త ప్రశ్న',
    answeredquestion: 'సమాధానం',
    startchat: 'సంభాషణ ప్రారంభించండి',
    noquestion: 'మీకు సమాధానం చెప్పడానికి ప్రశ్నలు లేవు.',
    netSlow:
      'మీ ఇంటర్నెట్ వేగం నెమ్మదిగా ఉంటుంది, మీ గోలీవ్ అనుభవం ప్రభావవంతంగా ఉండవచ్చు.',
    startNet: 'దయచేసి మీ ఇంటర్నెట్ కనెక్షన్‌ను ప్రారంభించండి',
    upgradeApp:
      'దయచేసి ఈ లక్షణాన్ని ఉపయోగించడానికి అనువర్తనాన్ని అప్‌గ్రేడ్ చేయండి.',
    appId: 'మొదట అనువర్తన ID పొందండి!',
    startCamera:
      'ప్రసారం ప్రారంభించడానికి కెమెరా మరియు నిల్వను యాక్సెస్ చేయడానికి గోలైవ్‌ను అనుమతించండి.',
    broadcastKicked: 'బ్రాడ్‌కాస్టర్ మిమ్మల్ని గది నుండి తరిమివేసాడు.',
    plzchat: 'చాట్ ప్రారంభించండి',
    liveItem: 'జీవించడానికి అంశాన్ని ఎంచుకోండి',
    changecategory: 'మీ వర్గాన్ని మార్చండి',
    CallingYou: 'నిన్ను పిలుస్తున్నారు...',
    For: 'కోసం',
    MPointGiveYou: 'MPoint మీకు ఇవ్వండి',
    accountMayBlock:
      'అనుచితమైన ప్రవర్తన లేదా లైంగిక మరియు హింసాత్మక కంటెంట్ మీ ఖాతాను నిషేధించి చట్ట అమలు అధికారులకు నివేదించవచ్చు.',
    writeComment: 'దయచేసి మొదట వ్యాఖ్య రాయండి!',
    addedQues: 'క్రొత్త ప్రశ్న జోడించబడింది',
    CallDND: 'కి కాల్ చేయండి',
    CallBusy: 'బిజీగా కాల్ చేయండి',
    Openlink: 'లింక్ తెరవండి',
    Wallet: 'Wallet',
    CallingggYou: 'మీరు పిలుస్తున్నారు ...',
    reportPost:
      'ఈ పోస్ట్‌ను నివేదించినందుకు ధన్యవాదాలు. మేము మీ ప్రతిస్పందనను రికార్డ్ చేసాము.',
    noWallet: 'వాలెట్ నగదు లేదు',
    Kindlyaskquestion: 'దయచేసి ప్రశ్న అడగండి.',
    wentwrong: 'ఎక్కడో తేడ జరిగింది',
    serverNotRespo: 'సర్వర్ స్పందించడం లేదు',
    IncreaseMPoint: 'MPoint పెంచండి',
    submitedques: 'మీ ప్రశ్న విజయవంతంగా సమర్పించబడింది.',
    Nobalance: 'బ్యాలెన్స్ లేదు',
    liveEnded: 'లైవ్ ముగిసింది.',
    sellYourProduct: 'మీ ఉత్పత్తిని అమ్మండి',
    inspireViewer: 'వస్తువులను కొనుగోలు చేయడానికి మీ వీక్షకుడిని ప్రేరేపించండి',
    earnOnClick: 'ప్రతి క్లిక్ / అమ్మకంలో సంపాదించారు',
    earnMPoint:
      'ప్రతి క్లిక్‌పై MPoint పొందండి మరియు ప్రతి వస్తువు అమ్మకానికి 30% వరకు సంపాదించండి',
    clickToliveItem: 'ఒకే క్లిక్‌తో ప్రత్యక్ష అంశం',
    boughtthisdeal: 'ప్రజలు ఈ ఒప్పందాన్ని కొనుగోలు చేశారు',
    saleprice: 'అమ్ముడు ధర:',
    makeLive: 'ప్రత్యక్ష ప్రసారం చేయండి',
    noProduct: 'మీకు ఏ ఉత్పత్తి లేదు',
    MoreItem: 'మరిన్ని అంశం',
    Close: 'దగ్గరగా',
    Position: 'స్థానం',
    NameName: 'పేరు',
    DurationTime: 'వ్యవధి సమయం',
    Score: 'స్కోరు',
    WINrupees: 'గెలుపు ₹ 10000',
    EventEnd: 'ఈవెంట్ ముగింపు',
    buyNow: 'ఇప్పుడే కొనండి'
  }
}

const i18n = new VueI18n({
  locale: 'hi', // set locale
  fallbackLocale: 'hi', // set fallback locale
  messages // set locale messages
})

export default i18n
